export const GEO_DATA: any = [
  {
    v: "北京市",
    c: [
      {
        v: "市辖区",
        c: [
          { v: "东城区" },
          { v: "丰台区" },
          { v: "大兴区" },
          { v: "密云区" },
          { v: "平谷区" },
          { v: "延庆区" },
          { v: "怀柔区" },
          { v: "房山区" },
          { v: "昌平区" },
          { v: "朝阳区" },
          { v: "海淀区" },
          { v: "石景山区" },
          { v: "西城区" },
          { v: "通州区" },
          { v: "门头沟区" },
          { v: "顺义区" },
        ],
      },
    ],
  },
  {
    v: "天津市",
    c: [
      {
        v: "市辖区",
        c: [
          { v: "东丽区" },
          { v: "北辰区" },
          { v: "南开区" },
          { v: "和平区" },
          { v: "宁河区" },
          { v: "宝坻区" },
          { v: "武清区" },
          { v: "河东区" },
          { v: "河北区" },
          { v: "河西区" },
          { v: "津南区" },
          { v: "滨海新区" },
          { v: "滨海高新区" },
          { v: "红桥区" },
          { v: "蓟州区" },
          { v: "西青区" },
          { v: "静海区" },
        ],
      },
    ],
  },
  {
    v: "河北省",
    c: [
      {
        v: "保定市",
        c: [
          { v: "博野县" },
          { v: "唐县" },
          { v: "安国市" },
          { v: "安新县" },
          { v: "定兴县" },
          { v: "定州市" },
          { v: "容城县" },
          { v: "徐水区" },
          { v: "易县" },
          { v: "曲阳县" },
          { v: "望都县" },
          { v: "涞水县" },
          { v: "涞源县" },
          { v: "涿州市" },
          { v: "清苑区" },
          { v: "满城区" },
          { v: "竞秀区" },
          { v: "莲池区" },
          { v: "蠡县" },
          { v: "阜平县" },
          { v: "雄县" },
          { v: "顺平县" },
          { v: "高碑店市" },
          { v: "高阳县" },
        ],
      },
      {
        v: "唐山市",
        c: [
          { v: "丰南区" },
          { v: "丰润区" },
          { v: "乐亭县" },
          { v: "古冶区" },
          { v: "开平区" },
          { v: "曹妃甸区" },
          { v: "滦南县" },
          { v: "滦县" },
          { v: "玉田县" },
          { v: "路北区" },
          { v: "路南区" },
          { v: "迁安市" },
          { v: "迁西县" },
          { v: "遵化市" },
        ],
      },
      {
        v: "廊坊市",
        c: [
          { v: "三河市" },
          { v: "固安县" },
          { v: "大厂回族自治县" },
          { v: "大城县" },
          { v: "安次区" },
          { v: "广阳区" },
          { v: "文安县" },
          { v: "永清县" },
          { v: "经济技术开发区" },
          { v: "霸州市" },
          { v: "香河县" },
        ],
      },
      {
        v: "张家口市",
        c: [
          { v: "万全区" },
          { v: "下花园区" },
          { v: "宣化区" },
          { v: "尚义县" },
          { v: "崇礼区" },
          { v: "康保县" },
          { v: "张北县" },
          { v: "怀安县" },
          { v: "怀来县" },
          { v: "桥东区" },
          { v: "桥西区" },
          { v: "沽源县" },
          { v: "涿鹿县" },
          { v: "蔚县" },
          { v: "赤城县" },
          { v: "阳原县" },
        ],
      },
      {
        v: "承德市",
        c: [
          { v: "丰宁满族自治县" },
          { v: "兴隆县" },
          { v: "双桥区" },
          { v: "双滦区" },
          { v: "围场满族蒙古族自治县" },
          { v: "宽城满族自治县" },
          { v: "平泉县" },
          { v: "承德县" },
          { v: "滦平县" },
          { v: "隆化县" },
          { v: "鹰手营子矿区" },
        ],
      },
      {
        v: "沧州市",
        c: [
          { v: "东光县" },
          { v: "临港经济技术开发区" },
          { v: "任丘市" },
          { v: "南皮县" },
          { v: "吴桥县" },
          { v: "孟村回族自治县" },
          { v: "新华区" },
          { v: "沧县" },
          { v: "河间市" },
          { v: "泊头市" },
          { v: "海兴县" },
          { v: "渤海新区" },
          { v: "献县" },
          { v: "盐山县" },
          { v: "肃宁县" },
          { v: "运河区" },
          { v: "青县" },
          { v: "黄骅市" },
        ],
      },
      {
        v: "石家庄市",
        c: [
          { v: "井陉县" },
          { v: "井陉矿区" },
          { v: "元氏县" },
          { v: "平山县" },
          { v: "新乐市" },
          { v: "新华区" },
          { v: "无极县" },
          { v: "晋州市" },
          { v: "栾城区" },
          { v: "桥西区" },
          { v: "正定县" },
          { v: "深泽县" },
          { v: "灵寿县" },
          { v: "经济技术开发区" },
          { v: "藁城区" },
          { v: "行唐县" },
          { v: "裕华区" },
          { v: "赞皇县" },
          { v: "赵县" },
          { v: "辛集市" },
          { v: "长安区" },
          { v: "高新区" },
          { v: "高邑县" },
          { v: "鹿泉区" },
        ],
      },
      {
        v: "秦皇岛市",
        c: [
          { v: "北戴河区" },
          { v: "北戴河新区" },
          { v: "卢龙县" },
          { v: "山海关区" },
          { v: "抚宁区" },
          { v: "昌黎县" },
          { v: "海港区" },
          { v: "青龙满族自治县" },
        ],
      },
      {
        v: "衡水市",
        c: [
          { v: "冀州区" },
          { v: "安平县" },
          { v: "故城县" },
          { v: "景县" },
          { v: "枣强县" },
          { v: "桃城区" },
          { v: "武强县" },
          { v: "武邑县" },
          { v: "深州市" },
          { v: "阜城县" },
          { v: "饶阳县" },
        ],
      },
      {
        v: "邢台市",
        c: [
          { v: "临城县" },
          { v: "临西县" },
          { v: "任县" },
          { v: "内丘县" },
          { v: "南和县" },
          { v: "南宫市" },
          { v: "威县" },
          { v: "宁晋县" },
          { v: "巨鹿县" },
          { v: "平乡县" },
          { v: "广宗县" },
          { v: "新河县" },
          { v: "柏乡县" },
          { v: "桥东区" },
          { v: "桥西区" },
          { v: "沙河市" },
          { v: "清河县" },
          { v: "邢台县" },
          { v: "隆尧县" },
        ],
      },
      {
        v: "邯郸市",
        c: [
          { v: "丛台区" },
          { v: "临漳县" },
          { v: "复兴区" },
          { v: "大名县" },
          { v: "峰峰矿区" },
          { v: "广平县" },
          { v: "成安县" },
          { v: "曲周县" },
          { v: "武安市" },
          { v: "永年区" },
          { v: "涉县" },
          { v: "磁县" },
          { v: "肥乡区" },
          { v: "邯山区" },
          { v: "邱县" },
          { v: "馆陶县" },
          { v: "高新技术产业开发区" },
          { v: "魏县" },
          { v: "鸡泽县" },
        ],
      },
      { v: "雄安新区", c: [{ v: "雄安新区" }] },
    ],
  },
  {
    v: "山西省",
    c: [
      {
        v: "临汾市",
        c: [
          { v: "乡宁县" },
          { v: "侯马市" },
          { v: "古县" },
          { v: "吉县" },
          { v: "大宁县" },
          { v: "安泽县" },
          { v: "尧都区" },
          { v: "曲沃县" },
          { v: "永和县" },
          { v: "汾西县" },
          { v: "洪洞县" },
          { v: "浮山县" },
          { v: "翼城县" },
          { v: "蒲县" },
          { v: "襄汾县" },
          { v: "隰县" },
          { v: "霍州市" },
        ],
      },
      {
        v: "吕梁市",
        c: [
          { v: "中阳县" },
          { v: "临县" },
          { v: "交口县" },
          { v: "交城县" },
          { v: "兴县" },
          { v: "孝义市" },
          { v: "岚县" },
          { v: "文水县" },
          { v: "方山县" },
          { v: "柳林县" },
          { v: "汾阳市" },
          { v: "石楼县" },
          { v: "离石区" },
        ],
      },
      {
        v: "大同市",
        c: [
          { v: "南郊区" },
          { v: "城区" },
          { v: "大同县" },
          { v: "天镇县" },
          { v: "左云县" },
          { v: "广灵县" },
          { v: "新荣区" },
          { v: "浑源县" },
          { v: "灵丘县" },
          { v: "矿区" },
          { v: "经济开发区" },
          { v: "阳高县" },
        ],
      },
      {
        v: "太原市",
        c: [
          { v: "万柏林区" },
          { v: "古交市" },
          { v: "娄烦县" },
          { v: "小店区" },
          { v: "尖草坪区" },
          { v: "晋源区" },
          { v: "杏花岭区" },
          { v: "清徐县" },
          { v: "迎泽区" },
          { v: "阳曲县" },
          { v: "高新姚村园区" },
          { v: "高新汾东园区" },
          { v: "高新阳曲园区" },
        ],
      },
      {
        v: "忻州市",
        c: [
          { v: "五台县" },
          { v: "五寨县" },
          { v: "代县" },
          { v: "保德县" },
          { v: "偏关县" },
          { v: "原平市" },
          { v: "宁武县" },
          { v: "定襄县" },
          { v: "岢岚县" },
          { v: "忻府区" },
          { v: "河曲县" },
          { v: "神池县" },
          { v: "繁峙县" },
          { v: "静乐县" },
        ],
      },
      {
        v: "晋中市",
        c: [
          { v: "介休市" },
          { v: "和顺县" },
          { v: "太谷县" },
          { v: "寿阳县" },
          { v: "左权县" },
          { v: "平遥县" },
          { v: "昔阳县" },
          { v: "榆次区" },
          { v: "榆社县" },
          { v: "灵石县" },
          { v: "祁县" },
        ],
      },
      { v: "晋城市", c: [{ v: "城区" }, { v: "沁水县" }, { v: "泽州县" }, { v: "经济开发区" }, { v: "阳城县" }, { v: "陵川县" }, { v: "高平市" }] },
      { v: "朔州市", c: [{ v: "右玉县" }, { v: "山阴县" }, { v: "平鲁区" }, { v: "应县" }, { v: "怀仁县" }, { v: "朔城区" }] },
      {
        v: "运城市",
        c: [
          { v: "万荣县" },
          { v: "临猗县" },
          { v: "垣曲县" },
          { v: "夏县" },
          { v: "平陆县" },
          { v: "新绛县" },
          { v: "永济市" },
          { v: "河津市" },
          { v: "盐湖区" },
          { v: "稷山县" },
          { v: "绛县" },
          { v: "芮城县" },
          { v: "闻喜县" },
        ],
      },
      {
        v: "长治市",
        c: [
          { v: "城区" },
          { v: "壶关县" },
          { v: "屯留县" },
          { v: "平顺县" },
          { v: "武乡县" },
          { v: "沁县" },
          { v: "沁源县" },
          { v: "潞城市" },
          { v: "襄垣县" },
          { v: "郊区" },
          { v: "长子县" },
          { v: "长治县" },
          { v: "黎城县" },
        ],
      },
      { v: "阳泉市", c: [{ v: "城区" }, { v: "平定县" }, { v: "盂县" }, { v: "矿区" }, { v: "郊区" }] },
    ],
  },
  {
    v: "内蒙古自治区",
    c: [
      {
        v: "乌兰察布市",
        c: [
          { v: "丰镇市" },
          { v: "兴和县" },
          { v: "凉城县" },
          { v: "化德县" },
          { v: "卓资县" },
          { v: "商都县" },
          { v: "四子王旗" },
          { v: "察哈尔右翼中旗" },
          { v: "察哈尔右翼前旗" },
          { v: "察哈尔右翼后旗" },
          { v: "集宁区" },
        ],
      },
      { v: "乌海市", c: [{ v: "乌达区" }, { v: "海勃湾区" }, { v: "海南区" }] },
      { v: "兴安盟", c: [{ v: "乌兰浩特市" }, { v: "扎赉特旗" }, { v: "科尔沁右翼中旗" }, { v: "科尔沁右翼前旗" }, { v: "突泉县" }, { v: "阿尔山市" }] },
      {
        v: "包头市",
        c: [
          { v: "东河区" },
          { v: "九原区" },
          { v: "固阳县" },
          { v: "土默特右旗" },
          { v: "昆都仑区" },
          { v: "白云鄂博矿区" },
          { v: "石拐区" },
          { v: "达尔罕茂明安联合旗" },
          { v: "青山区" },
        ],
      },
      {
        v: "呼伦贝尔市",
        c: [
          { v: "扎兰屯市" },
          { v: "扎赉诺尔区" },
          { v: "新巴尔虎右旗" },
          { v: "新巴尔虎左旗" },
          { v: "根河市" },
          { v: "海拉尔区" },
          { v: "满洲里市" },
          { v: "牙克石市" },
          { v: "莫力达瓦达斡尔族自治旗" },
          { v: "鄂伦春自治旗" },
          { v: "鄂温克族自治旗" },
          { v: "阿荣旗" },
          { v: "陈巴尔虎旗" },
          { v: "额尔古纳市" },
        ],
      },
      {
        v: "呼和浩特市",
        c: [
          { v: "和林格尔县" },
          { v: "回民区" },
          { v: "土默特左旗" },
          { v: "托克托县" },
          { v: "新城区" },
          { v: "武川县" },
          { v: "清水河县" },
          { v: "玉泉区" },
          { v: "赛罕区" },
        ],
      },
      {
        v: "巴彦淖尔市",
        c: [{ v: "临河区" }, { v: "乌拉特中旗" }, { v: "乌拉特前旗" }, { v: "乌拉特后旗" }, { v: "五原县" }, { v: "杭锦后旗" }, { v: "磴口县" }],
      },
      {
        v: "赤峰市",
        c: [
          { v: "元宝山区" },
          { v: "克什克腾旗" },
          { v: "喀喇沁旗" },
          { v: "宁城县" },
          { v: "巴林右旗" },
          { v: "巴林左旗" },
          { v: "敖汉旗" },
          { v: "松山区" },
          { v: "林西县" },
          { v: "红山区" },
          { v: "翁牛特旗" },
          { v: "阿鲁科尔沁旗" },
        ],
      },
      {
        v: "通辽市",
        c: [
          { v: "奈曼旗" },
          { v: "库伦旗" },
          { v: "开鲁县" },
          { v: "扎鲁特旗" },
          { v: "科尔沁区" },
          { v: "科尔沁左翼中旗" },
          { v: "科尔沁左翼后旗" },
          { v: "霍林郭勒市" },
        ],
      },
      {
        v: "鄂尔多斯市",
        c: [
          { v: "东胜区" },
          { v: "乌审旗" },
          { v: "伊金霍洛旗" },
          { v: "准格尔旗" },
          { v: "康巴什区" },
          { v: "杭锦旗" },
          { v: "达拉特旗" },
          { v: "鄂托克前旗" },
          { v: "鄂托克旗" },
        ],
      },
      {
        v: "锡林郭勒盟",
        c: [
          { v: "东乌珠穆沁旗" },
          { v: "二连浩特市" },
          { v: "多伦县" },
          { v: "太仆寺旗" },
          { v: "正蓝旗" },
          { v: "正镶白旗" },
          { v: "苏尼特右旗" },
          { v: "苏尼特左旗" },
          { v: "西乌珠穆沁旗" },
          { v: "锡林浩特市" },
          { v: "镶黄旗" },
          { v: "阿巴嘎旗" },
        ],
      },
      { v: "阿拉善盟", c: [{ v: "阿拉善右旗" }, { v: "阿拉善左旗" }, { v: "额济纳旗" }] },
    ],
  },
  {
    v: "辽宁省",
    c: [
      { v: "丹东市", c: [{ v: "东港市" }, { v: "元宝区" }, { v: "凤城市" }, { v: "宽甸满族自治县" }, { v: "振兴区" }, { v: "振安区" }] },
      {
        v: "大连市",
        c: [
          { v: "中山区" },
          { v: "庄河市" },
          { v: "旅顺口区" },
          { v: "普兰店区" },
          { v: "沙河口区" },
          { v: "瓦房店市" },
          { v: "甘井子区" },
          { v: "经济开发区" },
          { v: "西岗区" },
          { v: "金州区" },
          { v: "金普新区" },
          { v: "长海县" },
          { v: "高新区" },
        ],
      },
      {
        v: "抚顺市",
        c: [{ v: "东洲区" }, { v: "抚顺县" }, { v: "新宾满族自治县" }, { v: "新抚区" }, { v: "望花区" }, { v: "清原满族自治县" }, { v: "顺城区" }],
      },
      {
        v: "朝阳市",
        c: [{ v: "凌源市" }, { v: "北票市" }, { v: "双塔区" }, { v: "喀喇沁左翼蒙古族自治县" }, { v: "建平县" }, { v: "朝阳县" }, { v: "龙城区" }],
      },
      { v: "本溪市", c: [{ v: "南芬区" }, { v: "平山区" }, { v: "明山区" }, { v: "本溪满族自治县" }, { v: "桓仁满族自治县" }, { v: "溪湖区" }] },
      {
        v: "沈阳市",
        c: [
          { v: "于洪区" },
          { v: "和平区" },
          { v: "大东区" },
          { v: "康平县" },
          { v: "新民市" },
          { v: "沈北新区" },
          { v: "沈河区" },
          { v: "法库县" },
          { v: "浑南��区" },
          { v: "皇姑区" },
          { v: "苏家屯区" },
          { v: "辽中区" },
          { v: "铁西区" },
          { v: "高新区" },
        ],
      },
      { v: "盘锦市", c: [{ v: "兴隆台区" }, { v: "双台子区" }, { v: "大洼区" }, { v: "盘山县" }] },
      { v: "营口市", c: [{ v: "大石桥市" }, { v: "盖州市" }, { v: "站前区" }, { v: "老边区" }, { v: "西市区" }, { v: "鲅鱼圈区" }] },
      { v: "葫芦岛市", c: [{ v: "兴城市" }, { v: "南票区" }, { v: "建昌县" }, { v: "绥中县" }, { v: "连山区" }, { v: "龙港区" }] },
      { v: "辽阳市", c: [{ v: "太子河区" }, { v: "宏伟区" }, { v: "弓长岭区" }, { v: "文圣区" }, { v: "灯塔市" }, { v: "白塔区" }, { v: "辽阳县" }] },
      { v: "铁岭市", c: [{ v: "开原市" }, { v: "昌图县" }, { v: "清河区" }, { v: "西丰县" }, { v: "调兵山市" }, { v: "铁岭县" }, { v: "银州区" }] },
      {
        v: "锦州市",
        c: [
          { v: "义县" },
          { v: "凌河区" },
          { v: "凌海市" },
          { v: "北镇市" },
          { v: "古塔区" },
          { v: "太和区" },
          { v: "松山新区" },
          { v: "经济技术开发区" },
          { v: "黑山县" },
          { v: "龙栖湾新区" },
        ],
      },
      { v: "阜新市", c: [{ v: "太平区" }, { v: "彰武县" }, { v: "新邱区" }, { v: "海州区" }, { v: "清河门区" }, { v: "细河区" }, { v: "阜新蒙古族自治县" }] },
      {
        v: "鞍山市",
        c: [{ v: "千山区" }, { v: "台安县" }, { v: "岫岩满族自治县" }, { v: "海城市" }, { v: "立山区" }, { v: "铁东区" }, { v: "铁西区" }, { v: "高新区" }],
      },
    ],
  },
  {
    v: "吉林省",
    c: [
      {
        v: "吉林市",
        c: [
          { v: "丰满区" },
          { v: "昌邑区" },
          { v: "桦甸市" },
          { v: "永吉县" },
          { v: "磐石市" },
          { v: "舒兰市" },
          { v: "船营区" },
          { v: "蛟河市" },
          { v: "高新区" },
          { v: "龙潭区" },
        ],
      },
      { v: "四平市", c: [{ v: "伊通满族自治县" }, { v: "公主岭市" }, { v: "双辽市" }, { v: "梨树县" }, { v: "铁东区" }, { v: "铁西区" }] },
      {
        v: "延边朝鲜族自治州",
        c: [{ v: "和龙市" }, { v: "图们市" }, { v: "安图县" }, { v: "延吉市" }, { v: "敦化市" }, { v: "汪清县" }, { v: "珲春市" }, { v: "龙井市" }],
      },
      { v: "松原市", c: [{ v: "乾安县" }, { v: "前郭尔罗斯蒙古族自治县" }, { v: "宁江区" }, { v: "扶余市" }, { v: "长岭县" }] },
      { v: "白城市", c: [{ v: "大安市" }, { v: "洮北区" }, { v: "洮南市" }, { v: "通榆县" }, { v: "镇赉县" }] },
      { v: "白山市", c: [{ v: "临江市" }, { v: "抚松县" }, { v: "江源区" }, { v: "浑江区" }, { v: "长白朝鲜族自治县" }, { v: "靖宇县" }] },
      { v: "辽源市", c: [{ v: "东丰县" }, { v: "东辽县" }, { v: "西安区" }, { v: "龙山区" }] },
      { v: "通化市", c: [{ v: "东昌区" }, { v: "二道江区" }, { v: "柳河县" }, { v: "梅河口市" }, { v: "辉南县" }, { v: "通化县" }, { v: "集安市" }] },
      {
        v: "长春市",
        c: [
          { v: "九台区" },
          { v: "二道区" },
          { v: "兴隆综合保税区" },
          { v: "农安县" },
          { v: "南关区" },
          { v: "双阳区" },
          { v: "宽城区" },
          { v: "德惠市" },
          { v: "朝阳区" },
          { v: "榆树市" },
          { v: "汽车产业开发区" },
          { v: "经济技术开发区" },
          { v: "绿园区" },
          { v: "长春新区" },
          { v: "高新技术产业开发区" },
        ],
      },
    ],
  },
  {
    v: "黑龙江省",
    c: [
      { v: "七台河市", c: [{ v: "勃利县" }, { v: "新兴区" }, { v: "桃山区" }, { v: "茄子河区" }] },
      {
        v: "伊春市",
        c: [
          { v: "上甘岭区" },
          { v: "乌伊岭区" },
          { v: "乌马河区" },
          { v: "五营区" },
          { v: "伊春区" },
          { v: "南岔区" },
          { v: "友好区" },
          { v: "嘉荫县" },
          { v: "带岭区" },
          { v: "新青区" },
          { v: "汤旺河区" },
          { v: "红星区" },
          { v: "美溪区" },
          { v: "翠峦区" },
          { v: "西林区" },
          { v: "金山屯区" },
          { v: "铁力市" },
        ],
      },
      {
        v: "佳木斯市",
        c: [
          { v: "东风区" },
          { v: "前进区" },
          { v: "同江市" },
          { v: "向阳区" },
          { v: "富锦市" },
          { v: "抚远市" },
          { v: "桦南县" },
          { v: "桦川县" },
          { v: "汤原县" },
          { v: "郊区" },
        ],
      },
      {
        v: "双鸭山市",
        c: [{ v: "友谊县" }, { v: "四方台区" }, { v: "宝山区" }, { v: "宝清县" }, { v: "尖山区" }, { v: "岭东区" }, { v: "集贤县" }, { v: "饶河县" }],
      },
      {
        v: "哈尔滨市",
        c: [
          { v: "五常市" },
          { v: "依兰县" },
          { v: "南岗区" },
          { v: "双城区" },
          { v: "呼兰区" },
          { v: "哈尔滨新区" },
          { v: "宾县" },
          { v: "尚志市" },
          { v: "巴彦县" },
          { v: "平房区" },
          { v: "延寿县" },
          { v: "方正县" },
          { v: "木兰县" },
          { v: "松北区" },
          { v: "通河县" },
          { v: "道外区" },
          { v: "道里区" },
          { v: "阿城区" },
          { v: "香坊区" },
          { v: "高新区" },
        ],
      },
      { v: "大兴安岭地区", c: [{ v: "加格达奇区" }, { v: "呼中区" }, { v: "呼玛县" }, { v: "塔河县" }, { v: "新林区" }, { v: "松岭区" }, { v: "漠河县" }] },
      {
        v: "大庆市",
        c: [
          { v: "大同区" },
          { v: "杜尔伯特蒙古族自治县" },
          { v: "林甸县" },
          { v: "红岗区" },
          { v: "肇州县" },
          { v: "肇源县" },
          { v: "萨尔图区" },
          { v: "让胡路区" },
          { v: "高新区" },
          { v: "龙凤区" },
        ],
      },
      {
        v: "牡丹江市",
        c: [
          { v: "东宁市" },
          { v: "东安区" },
          { v: "宁安市" },
          { v: "林口县" },
          { v: "海林市" },
          { v: "爱民区" },
          { v: "穆棱市" },
          { v: "绥芬河市" },
          { v: "西安区" },
          { v: "阳明区" },
        ],
      },
      {
        v: "绥化市",
        c: [
          { v: "兰西县" },
          { v: "北林区" },
          { v: "安达市" },
          { v: "庆安县" },
          { v: "明水县" },
          { v: "望奎县" },
          { v: "海伦市" },
          { v: "绥棱县" },
          { v: "肇东市" },
          { v: "青冈县" },
        ],
      },
      {
        v: "鸡西市",
        c: [
          { v: "城子河区" },
          { v: "密山市" },
          { v: "恒山区" },
          { v: "梨树区" },
          { v: "滴道区" },
          { v: "虎林市" },
          { v: "鸡东县" },
          { v: "鸡冠区" },
          { v: "麻山区" },
        ],
      },
      {
        v: "鹤岗市",
        c: [{ v: "东山区" }, { v: "兴安区" }, { v: "兴山区" }, { v: "南山区" }, { v: "向阳区" }, { v: "工农区" }, { v: "绥滨县" }, { v: "萝北县" }],
      },
      { v: "黑河市", c: [{ v: "五大连池市" }, { v: "北安市" }, { v: "嫩江县" }, { v: "孙吴县" }, { v: "爱辉区" }, { v: "逊克县" }] },
      {
        v: "齐齐哈尔市",
        c: [
          { v: "依安县" },
          { v: "克东县" },
          { v: "克山县" },
          { v: "富拉尔基区" },
          { v: "富裕县" },
          { v: "建华区" },
          { v: "拜泉县" },
          { v: "昂昂溪区" },
          { v: "梅里斯达斡尔族区" },
          { v: "泰来县" },
          { v: "甘南县" },
          { v: "碾子山区" },
          { v: "讷河市" },
          { v: "铁锋区" },
          { v: "高新区" },
          { v: "龙江县" },
          { v: "龙沙区" },
        ],
      },
    ],
  },
  {
    v: "上海市",
    c: [
      {
        v: "市辖区",
        c: [
          { v: "嘉定区" },
          { v: "奉贤区" },
          { v: "宝山区" },
          { v: "崇明区" },
          { v: "张江高新区" },
          { v: "徐汇区" },
          { v: "普陀区" },
          { v: "杨浦区" },
          { v: "松江区" },
          { v: "浦东新区" },
          { v: "漕河泾开发区" },
          { v: "紫竹高新区" },
          { v: "虹口区" },
          { v: "金山区" },
          { v: "长宁区" },
          { v: "闵行区" },
          { v: "青浦区" },
          { v: "静安区" },
          { v: "黄浦区" },
        ],
      },
    ],
  },
  {
    v: "江苏省",
    c: [
      {
        v: "南京市",
        c: [
          { v: "六合区" },
          { v: "建邺区" },
          { v: "栖霞区" },
          { v: "江北新区" },
          { v: "江宁区" },
          { v: "浦口区" },
          { v: "溧水区" },
          { v: "玄武区" },
          { v: "秦淮区" },
          { v: "雨花台区" },
          { v: "高淳区" },
          { v: "鼓楼区" },
        ],
      },
      {
        v: "南通市",
        c: [
          { v: "启东市" },
          { v: "如东县" },
          { v: "如皋市" },
          { v: "崇川区" },
          { v: "海安县" },
          { v: "海门市" },
          { v: "港闸区" },
          { v: "经济技术开发区" },
          { v: "通州区" },
        ],
      },
      { v: "宿迁市", c: [{ v: "宿城区" }, { v: "宿豫区" }, { v: "沭阳县" }, { v: "泗洪县" }, { v: "泗阳县" }, { v: "经济开发区" }] },
      { v: "常州市", c: [{ v: "天宁区" }, { v: "新北区" }, { v: "武进区" }, { v: "溧阳市" }, { v: "金坛区" }, { v: "钟楼区" }, { v: "高新区" }] },
      {
        v: "徐州市",
        c: [
          { v: "丰县" },
          { v: "云龙区" },
          { v: "新沂市" },
          { v: "沛县" },
          { v: "泉山区" },
          { v: "睢宁县" },
          { v: "经济技术开发区" },
          { v: "贾汪区" },
          { v: "软件园" },
          { v: "邳州市" },
          { v: "铜山区" },
          { v: "高新技术产业开发区" },
          { v: "鼓楼区" },
        ],
      },
      { v: "扬州市", c: [{ v: "仪征市" }, { v: "宝应县" }, { v: "广陵区" }, { v: "江都区" }, { v: "邗江区" }, { v: "高邮市" }] },
      { v: "无锡市", c: [{ v: "宜兴市" }, { v: "惠山区" }, { v: "新吴区" }, { v: "梁溪区" }, { v: "江阴市" }, { v: "滨湖区" }, { v: "锡山区" }] },
      { v: "泰州市", c: [{ v: "兴化市" }, { v: "姜堰区" }, { v: "泰兴市" }, { v: "海陵区" }, { v: "靖江市" }, { v: "高港区" }] },
      {
        v: "淮安市",
        c: [{ v: "洪泽区" }, { v: "涟水县" }, { v: "淮安区" }, { v: "淮阴区" }, { v: "清江浦区" }, { v: "盱眙县" }, { v: "经济开发区" }, { v: "金湖县" }],
      },
      {
        v: "盐城市",
        c: [
          { v: "东台市" },
          { v: "亭湖区" },
          { v: "响水县" },
          { v: "大丰区" },
          { v: "射阳县" },
          { v: "建湖县" },
          { v: "滨海县" },
          { v: "盐都区" },
          { v: "阜宁县" },
        ],
      },
      {
        v: "苏州市",
        c: [
          { v: "吴中区" },
          { v: "吴江区" },
          { v: "太仓市" },
          { v: "姑苏区" },
          { v: "工业园区" },
          { v: "常熟市" },
          { v: "张家港市" },
          { v: "昆山市" },
          { v: "相城区" },
          { v: "苏州新区" },
          { v: "虎丘区" },
          { v: "高新区" },
        ],
      },
      { v: "连云港市", c: [{ v: "东海县" }, { v: "海州区" }, { v: "灌云县" }, { v: "灌南县" }, { v: "赣榆区" }, { v: "连云区" }] },
      {
        v: "镇江市",
        c: [
          { v: "丹徒区" },
          { v: "丹徒新区" },
          { v: "丹阳市" },
          { v: "京口区" },
          { v: "句容市" },
          { v: "扬中市" },
          { v: "润州区" },
          { v: "经济开发区" },
          { v: "镇江新区" },
        ],
      },
    ],
  },
  {
    v: "浙江省",
    c: [
      {
        v: "丽水市",
        c: [
          { v: "云和县" },
          { v: "庆元县" },
          { v: "景宁畲族自治县" },
          { v: "松阳县" },
          { v: "缙云县" },
          { v: "莲都区" },
          { v: "遂昌县" },
          { v: "青田县" },
          { v: "龙泉市" },
        ],
      },
      {
        v: "台州市",
        c: [
          { v: "三门县" },
          { v: "临海市" },
          { v: "仙居县" },
          { v: "天台县" },
          { v: "椒江区" },
          { v: "温岭市" },
          { v: "玉环县" },
          { v: "路桥区" },
          { v: "黄岩区" },
        ],
      },
      { v: "嘉兴市", c: [{ v: "南湖区" }, { v: "嘉善县" }, { v: "平湖市" }, { v: "桐乡市" }, { v: "海宁市" }, { v: "海盐县" }, { v: "秀洲区" }] },
      {
        v: "宁波市",
        c: [
          { v: "余姚市" },
          { v: "北仑区" },
          { v: "奉化区" },
          { v: "宁海县" },
          { v: "慈溪市" },
          { v: "杭州湾新区" },
          { v: "江北区" },
          { v: "海曙区" },
          { v: "象山县" },
          { v: "鄞州区" },
          { v: "镇海区" },
          { v: "高新区" },
        ],
      },
      {
        v: "杭州市",
        c: [
          { v: "上城区" },
          { v: "下城区" },
          { v: "临安市" },
          { v: "余杭区" },
          { v: "富阳区" },
          { v: "建德市" },
          { v: "拱墅区" },
          { v: "桐庐县" },
          { v: "江干区" },
          { v: "淳安县" },
          { v: "滨江区" },
          { v: "萧山区" },
          { v: "西湖区" },
          { v: "高新区" },
        ],
      },
      {
        v: "温州市",
        c: [
          { v: "乐清市" },
          { v: "平阳县" },
          { v: "文成县" },
          { v: "永嘉县" },
          { v: "泰顺县" },
          { v: "洞头区" },
          { v: "瑞安市" },
          { v: "瓯海区" },
          { v: "苍南县" },
          { v: "鹿城区" },
          { v: "龙湾区" },
        ],
      },
      { v: "湖州市", c: [{ v: "南浔区" }, { v: "吴兴区" }, { v: "安吉县" }, { v: "德清县" }, { v: "长兴县" }] },
      { v: "绍兴市", c: [{ v: "上虞区" }, { v: "嵊州市" }, { v: "新昌县" }, { v: "柯桥区" }, { v: "诸暨市" }, { v: "越城区" }] },
      { v: "舟山市", c: [{ v: "定海区" }, { v: "岱山县" }, { v: "嵊泗县" }, { v: "普陀区" }] },
      {
        v: "舟山群岛新区",
        c: [
          { v: "六横岛" },
          { v: "岱山岛西南部" },
          { v: "朱家尖岛" },
          { v: "泗礁岛" },
          { v: "洋山岛" },
          { v: "舟山本岛西北部" },
          { v: "虾峙岛" },
          { v: "衢山岛" },
          { v: "金塘岛" },
          { v: "长涂岛" },
        ],
      },
      { v: "衢州市", c: [{ v: "常山县" }, { v: "开化县" }, { v: "柯城区" }, { v: "江山市" }, { v: "衢江区" }, { v: "龙游县" }] },
      {
        v: "金华市",
        c: [
          { v: "东阳市" },
          { v: "义乌市" },
          { v: "兰溪市" },
          { v: "婺城区" },
          { v: "武义县" },
          { v: "永康市" },
          { v: "浦江县" },
          { v: "磐安县" },
          { v: "金东区" },
        ],
      },
    ],
  },
  {
    v: "安徽省",
    c: [
      { v: "亳州市", c: [{ v: "利辛县" }, { v: "涡阳县" }, { v: "蒙城县" }, { v: "谯城区" }] },
      { v: "六安市", c: [{ v: "叶集区" }, { v: "舒城县" }, { v: "裕安区" }, { v: "金安区" }, { v: "金寨县" }, { v: "霍山县" }, { v: "霍邱县" }] },
      {
        v: "合肥市",
        c: [
          { v: "包河区" },
          { v: "北城新区" },
          { v: "巢湖市" },
          { v: "庐江县" },
          { v: "庐阳区" },
          { v: "政务文化新区" },
          { v: "新站综合开发试验区" },
          { v: "滨湖新区" },
          { v: "瑶海区" },
          { v: "经济技术开发区" },
          { v: "肥东县" },
          { v: "肥西县" },
          { v: "蜀山区" },
          { v: "长丰县" },
          { v: "高新技术开发区" },
        ],
      },
      {
        v: "安庆市",
        c: [
          { v: "大观区" },
          { v: "太湖县" },
          { v: "宜秀区" },
          { v: "宿松县" },
          { v: "岳西县" },
          { v: "怀宁县" },
          { v: "望江县" },
          { v: "桐城市" },
          { v: "潜山县" },
          { v: "迎江区" },
        ],
      },
      { v: "宣城市", c: [{ v: "宁国市" }, { v: "宣州区" }, { v: "广德县" }, { v: "旌德县" }, { v: "泾县" }, { v: "绩溪县" }, { v: "郎溪县" }] },
      { v: "宿州市", c: [{ v: "埇桥区" }, { v: "泗县" }, { v: "灵璧县" }, { v: "砀山县" }, { v: "经济开发区" }, { v: "萧县" }] },
      { v: "池州市", c: [{ v: "东至县" }, { v: "石台县" }, { v: "贵池区" }, { v: "青阳县" }] },
      { v: "淮北市", c: [{ v: "杜集区" }, { v: "濉溪县" }, { v: "烈山区" }, { v: "相山区" }] },
      {
        v: "淮南市",
        c: [
          { v: "八公山区" },
          { v: "凤台县" },
          { v: "大通区" },
          { v: "寿县" },
          { v: "山南新区" },
          { v: "毛集实验区" },
          { v: "潘集区" },
          { v: "田家庵区" },
          { v: "经济开发区" },
          { v: "谢家集区" },
        ],
      },
      {
        v: "滁州市",
        c: [{ v: "全椒县" }, { v: "凤阳县" }, { v: "南谯区" }, { v: "天长市" }, { v: "定远县" }, { v: "明光市" }, { v: "来安县" }, { v: "琅琊区" }],
      },
      {
        v: "芜湖市",
        c: [
          { v: "三山区" },
          { v: "南陵县" },
          { v: "弋江区" },
          { v: "无为县" },
          { v: "繁昌县" },
          { v: "经济技术开发区" },
          { v: "芜湖县" },
          { v: "镜湖区" },
          { v: "鸠江区" },
        ],
      },
      {
        v: "蚌埠市",
        c: [{ v: "五河县" }, { v: "固镇县" }, { v: "怀远县" }, { v: "淮上区" }, { v: "禹会区" }, { v: "蚌山区" }, { v: "高新区" }, { v: "龙子湖区" }],
      },
      { v: "铜陵市", c: [{ v: "义安区" }, { v: "枞阳县" }, { v: "郊区" }, { v: "铜官区" }] },
      {
        v: "阜阳市",
        c: [
          { v: "临泉县" },
          { v: "太和县" },
          { v: "界首市" },
          { v: "经济开发区" },
          { v: "阜南县" },
          { v: "颍上县" },
          { v: "颍东区" },
          { v: "颍州区" },
          { v: "颍泉区" },
        ],
      },
      { v: "马鞍山市", c: [{ v: "博望区" }, { v: "含山县" }, { v: "和县" }, { v: "当涂县" }, { v: "花山区" }, { v: "雨山区" }] },
      { v: "黄山市", c: [{ v: "休宁县" }, { v: "屯溪区" }, { v: "徽州区" }, { v: "歙县" }, { v: "祁门县" }, { v: "黄山区" }, { v: "黟县" }] },
    ],
  },
  {
    v: "福建省",
    c: [
      {
        v: "三明市",
        c: [
          { v: "三元区" },
          { v: "大田县" },
          { v: "宁化县" },
          { v: "将乐县" },
          { v: "尤溪县" },
          { v: "建宁县" },
          { v: "明溪县" },
          { v: "梅列区" },
          { v: "永安市" },
          { v: "沙县" },
          { v: "泰宁县" },
          { v: "清流县" },
        ],
      },
      {
        v: "南平市",
        c: [
          { v: "光泽县" },
          { v: "延平区" },
          { v: "建瓯市" },
          { v: "建阳区" },
          { v: "政和县" },
          { v: "松溪县" },
          { v: "武夷山市" },
          { v: "浦城县" },
          { v: "邵武市" },
          { v: "顺昌县" },
        ],
      },
      { v: "厦门市", c: [{ v: "同安区" }, { v: "思明区" }, { v: "海沧区" }, { v: "湖里区" }, { v: "翔安区" }, { v: "集美区" }] },
      {
        v: "宁德市",
        c: [
          { v: "东侨开发区" },
          { v: "古田县" },
          { v: "周宁县" },
          { v: "寿宁县" },
          { v: "屏南县" },
          { v: "柘荣县" },
          { v: "福安市" },
          { v: "福鼎市" },
          { v: "蕉城区" },
          { v: "霞浦县" },
        ],
      },
      {
        v: "泉州市",
        c: [
          { v: "丰泽区" },
          { v: "南安市" },
          { v: "台商投资区" },
          { v: "安溪县" },
          { v: "德化县" },
          { v: "惠安县" },
          { v: "晋江市" },
          { v: "永春县" },
          { v: "泉港区" },
          { v: "洛江区" },
          { v: "石狮市" },
          { v: "经济技术开发区" },
          { v: "综合保税区" },
          { v: "金门县" },
          { v: "高新技术开发区" },
          { v: "鲤城区" },
        ],
      },
      {
        v: "漳州市",
        c: [
          { v: "东山县" },
          { v: "云霄县" },
          { v: "华安县" },
          { v: "南靖县" },
          { v: "平和县" },
          { v: "漳浦县" },
          { v: "芗城区" },
          { v: "诏安县" },
          { v: "长泰县" },
          { v: "龙文区" },
          { v: "龙海市" },
        ],
      },
      {
        v: "福州市",
        c: [
          { v: "仓山区" },
          { v: "台江区" },
          { v: "平潭县" },
          { v: "晋安区" },
          { v: "永泰县" },
          { v: "福州新区" },
          { v: "福清市" },
          { v: "罗源县" },
          { v: "连江县" },
          { v: "长乐市" },
          { v: "闽侯县" },
          { v: "闽清县" },
          { v: "马尾区" },
          { v: "鼓楼区" },
        ],
      },
      { v: "莆田市", c: [{ v: "仙游县" }, { v: "城厢区" }, { v: "涵江区" }, { v: "秀屿区" }, { v: "荔城区" }] },
      { v: "龙岩市", c: [{ v: "上杭县" }, { v: "新罗区" }, { v: "武平县" }, { v: "永定区" }, { v: "漳平市" }, { v: "连城县" }, { v: "长汀县" }] },
    ],
  },
  {
    v: "江西省",
    c: [
      {
        v: "上饶市",
        c: [
          { v: "万年县" },
          { v: "上饶县" },
          { v: "余干县" },
          { v: "信州区" },
          { v: "婺源县" },
          { v: "广丰区" },
          { v: "弋阳县" },
          { v: "德兴市" },
          { v: "横峰县" },
          { v: "玉山县" },
          { v: "鄱阳县" },
          { v: "铅山县" },
        ],
      },
      {
        v: "九江市",
        c: [
          { v: "九江县" },
          { v: "修水县" },
          { v: "八里湖新区" },
          { v: "共青城市" },
          { v: "庐山市" },
          { v: "庐山风景名胜区" },
          { v: "彭泽县" },
          { v: "德安县" },
          { v: "武宁县" },
          { v: "永修县" },
          { v: "浔阳区" },
          { v: "湖口县" },
          { v: "濂溪区" },
          { v: "瑞昌市" },
          { v: "经济技术开发区" },
          { v: "都昌县" },
        ],
      },
      {
        v: "南昌市",
        c: [
          { v: "东湖区" },
          { v: "南昌县" },
          { v: "安义县" },
          { v: "小蓝开发区" },
          { v: "新建区" },
          { v: "望城新区" },
          { v: "桑海开发区" },
          { v: "湾里区" },
          { v: "红谷滩新区" },
          { v: "经济开发区" },
          { v: "西湖区" },
          { v: "赣江新区" },
          { v: "进贤县" },
          { v: "青云谱区" },
          { v: "青山湖区" },
          { v: "高新区" },
        ],
      },
      {
        v: "吉安市",
        c: [
          { v: "万安县" },
          { v: "井冈山市" },
          { v: "吉安县" },
          { v: "吉州区" },
          { v: "吉水县" },
          { v: "安福县" },
          { v: "峡江县" },
          { v: "新干县" },
          { v: "永丰县" },
          { v: "永新县" },
          { v: "泰和县" },
          { v: "遂川县" },
          { v: "青原区" },
        ],
      },
      {
        v: "宜春市",
        c: [
          { v: "万载县" },
          { v: "上高县" },
          { v: "丰城市" },
          { v: "奉新县" },
          { v: "宜丰县" },
          { v: "樟树市" },
          { v: "袁州区" },
          { v: "铜鼓县" },
          { v: "靖安县" },
          { v: "高安市" },
        ],
      },
      {
        v: "抚州市",
        c: [
          { v: "东乡县" },
          { v: "临川区" },
          { v: "乐安县" },
          { v: "南丰县" },
          { v: "南城县" },
          { v: "宜黄县" },
          { v: "崇仁县" },
          { v: "广昌县" },
          { v: "资溪县" },
          { v: "金溪县" },
          { v: "黎川县" },
        ],
      },
      { v: "新余市", c: [{ v: "分宜县" }, { v: "渝水区" }] },
      { v: "景德镇市", c: [{ v: "乐平市" }, { v: "昌江区" }, { v: "浮梁县" }, { v: "珠山区" }] },
      { v: "萍乡市", c: [{ v: "上栗县" }, { v: "安源区" }, { v: "湘东区" }, { v: "芦溪县" }, { v: "莲花县" }] },
      {
        v: "赣州市",
        c: [
          { v: "上犹县" },
          { v: "于都县" },
          { v: "会昌县" },
          { v: "信丰县" },
          { v: "全南县" },
          { v: "兴国县" },
          { v: "南康区" },
          { v: "大余县" },
          { v: "宁都县" },
          { v: "安远县" },
          { v: "定南县" },
          { v: "寻乌县" },
          { v: "崇义县" },
          { v: "瑞金市" },
          { v: "石城县" },
          { v: "章康新区" },
          { v: "章贡区" },
          { v: "赣县区" },
          { v: "龙南县" },
        ],
      },
      { v: "鹰潭市", c: [{ v: "余江县" }, { v: "月湖区" }, { v: "贵溪市" }] },
    ],
  },
  {
    v: "山东省",
    c: [
      { v: "东营市", c: [{ v: "东营区" }, { v: "利津县" }, { v: "垦利区" }, { v: "广饶县" }, { v: "河口区" }] },
      {
        v: "临沂市",
        c: [
          { v: "临沭县" },
          { v: "兰山区" },
          { v: "兰陵县" },
          { v: "平邑县" },
          { v: "沂南县" },
          { v: "沂水县" },
          { v: "河东区" },
          { v: "罗庄区" },
          { v: "莒南县" },
          { v: "蒙阴县" },
          { v: "费县" },
          { v: "郯城县" },
        ],
      },
      { v: "威海市", c: [{ v: "乳山市" }, { v: "文登区" }, { v: "环翠区" }, { v: "荣成市" }] },
      {
        v: "德州市",
        c: [
          { v: "临邑县" },
          { v: "乐陵市" },
          { v: "夏津县" },
          { v: "宁津县" },
          { v: "平原县" },
          { v: "庆云县" },
          { v: "德城区" },
          { v: "武城县" },
          { v: "禹城市" },
          { v: "陵城区" },
          { v: "齐河县" },
        ],
      },
      { v: "日照市", c: [{ v: "东港区" }, { v: "五莲县" }, { v: "岚山区" }, { v: "莒县" }] },
      { v: "枣庄市", c: [{ v: "台儿庄区" }, { v: "山亭区" }, { v: "峄城区" }, { v: "市中区" }, { v: "滕州市" }, { v: "薛城区" }, { v: "高新区" }] },
      { v: "泰安市", c: [{ v: "东平县" }, { v: "宁阳县" }, { v: "岱岳区" }, { v: "新泰市" }, { v: "泰山区" }, { v: "肥城市" }] },
      {
        v: "济南市",
        c: [
          { v: "历下区" },
          { v: "历城区" },
          { v: "商河县" },
          { v: "天桥区" },
          { v: "市中区" },
          { v: "平阴县" },
          { v: "槐荫区" },
          { v: "济阳县" },
          { v: "章丘区" },
          { v: "长清区" },
          { v: "高新区" },
        ],
      },
      {
        v: "济宁市",
        c: [
          { v: "任城区" },
          { v: "兖州区" },
          { v: "嘉祥县" },
          { v: "微山县" },
          { v: "曲阜市" },
          { v: "梁山县" },
          { v: "汶上县" },
          { v: "泗水县" },
          { v: "邹城市" },
          { v: "金乡县" },
          { v: "高新区" },
          { v: "鱼台县" },
        ],
      },
      {
        v: "淄博市",
        c: [
          { v: "临淄区" },
          { v: "博山区" },
          { v: "周村区" },
          { v: "张店区" },
          { v: "桓台县" },
          { v: "沂源县" },
          { v: "淄川区" },
          { v: "高新区" },
          { v: "高青县" },
        ],
      },
      {
        v: "滨州市",
        c: [{ v: "北海新区" }, { v: "博兴县" }, { v: "惠民县" }, { v: "无棣县" }, { v: "沾化区" }, { v: "滨城区" }, { v: "邹平县" }, { v: "阳信县" }],
      },
      {
        v: "潍坊市",
        c: [
          { v: "临朐县" },
          { v: "坊子区" },
          { v: "奎文区" },
          { v: "安丘市" },
          { v: "寒亭区" },
          { v: "寿光市" },
          { v: "昌乐县" },
          { v: "昌邑市" },
          { v: "潍城区" },
          { v: "诸城市" },
          { v: "青州市" },
          { v: "高密市" },
          { v: "高新区" },
        ],
      },
      {
        v: "烟台市",
        c: [
          { v: "招远市" },
          { v: "栖霞市" },
          { v: "海阳市" },
          { v: "牟平区" },
          { v: "福山区" },
          { v: "经济开发区" },
          { v: "芝罘区" },
          { v: "莱山区" },
          { v: "莱州市" },
          { v: "莱阳市" },
          { v: "蓬莱市" },
          { v: "长岛县" },
          { v: "高新区" },
          { v: "龙口市" },
        ],
      },
      {
        v: "聊城市",
        c: [{ v: "东昌府区" }, { v: "东阿县" }, { v: "临清市" }, { v: "冠县" }, { v: "茌平县" }, { v: "莘县" }, { v: "阳谷县" }, { v: "高唐县" }],
      },
      { v: "莱芜市", c: [{ v: "莱城区" }, { v: "钢城区" }] },
      {
        v: "菏泽市",
        c: [
          { v: "东明县" },
          { v: "单县" },
          { v: "定陶区" },
          { v: "巨野县" },
          { v: "成武县" },
          { v: "曹县" },
          { v: "牡丹区" },
          { v: "郓城县" },
          { v: "鄄城县" },
        ],
      },
      {
        v: "青岛市",
        c: [
          { v: "即墨市" },
          { v: "城阳区" },
          { v: "崂山区" },
          { v: "市北区" },
          { v: "市南区" },
          { v: "平度市" },
          { v: "李沧区" },
          { v: "胶州市" },
          { v: "莱西市" },
          { v: "西海岸新区" },
          { v: "高新区" },
          { v: "黄岛区" },
        ],
      },
    ],
  },
  {
    v: "河南省",
    c: [
      { v: "三门峡市", c: [{ v: "义马市" }, { v: "卢氏县" }, { v: "渑池县" }, { v: "湖滨区" }, { v: "灵宝市" }, { v: "陕州区" }] },
      {
        v: "信阳市",
        c: [
          { v: "光山县" },
          { v: "商城县" },
          { v: "固始县" },
          { v: "平桥区" },
          { v: "息县" },
          { v: "新县" },
          { v: "浉河区" },
          { v: "淮滨县" },
          { v: "潢川县" },
          { v: "罗山县" },
        ],
      },
      {
        v: "南阳市",
        c: [
          { v: "内乡县" },
          { v: "南召县" },
          { v: "卧龙区" },
          { v: "唐河县" },
          { v: "宛城区" },
          { v: "新野县" },
          { v: "方城县" },
          { v: "桐柏县" },
          { v: "淅川县" },
          { v: "社旗县" },
          { v: "西峡县" },
          { v: "邓州市" },
          { v: "镇平县" },
        ],
      },
      {
        v: "周口市",
        c: [
          { v: "东新区" },
          { v: "商水县" },
          { v: "太康县" },
          { v: "川汇区" },
          { v: "扶沟县" },
          { v: "沈丘县" },
          { v: "淮阳县" },
          { v: "经济开发区" },
          { v: "西华县" },
          { v: "郸城县" },
          { v: "项城市" },
          { v: "鹿邑县" },
        ],
      },
      {
        v: "商丘市",
        c: [
          { v: "夏邑县" },
          { v: "宁陵县" },
          { v: "柘城县" },
          { v: "梁园区" },
          { v: "民权县" },
          { v: "永城市" },
          { v: "睢县" },
          { v: "睢阳区" },
          { v: "虞城县" },
        ],
      },
      {
        v: "安阳市",
        c: [
          { v: "内黄县" },
          { v: "北关区" },
          { v: "安阳县" },
          { v: "安阳新区" },
          { v: "文峰区" },
          { v: "林州市" },
          { v: "殷都区" },
          { v: "汤阴县" },
          { v: "滑县" },
          { v: "龙安区" },
        ],
      },
      {
        v: "平顶山市",
        c: [
          { v: "卫东区" },
          { v: "叶县" },
          { v: "宝丰县" },
          { v: "新华区" },
          { v: "汝州市" },
          { v: "湛河区" },
          { v: "石龙区" },
          { v: "舞钢市" },
          { v: "郏县" },
          { v: "鲁山县" },
        ],
      },
      {
        v: "开封市",
        c: [
          { v: "兰考县" },
          { v: "尉氏县" },
          { v: "杞县" },
          { v: "祥符区" },
          { v: "禹王台区" },
          { v: "经济技术开发区" },
          { v: "通许县" },
          { v: "顺河回族区" },
          { v: "鼓楼区" },
          { v: "龙亭区" },
        ],
      },
      {
        v: "新乡市",
        c: [
          { v: "凤泉区" },
          { v: "卫滨区" },
          { v: "卫辉市" },
          { v: "原阳县" },
          { v: "封丘县" },
          { v: "延津县" },
          { v: "新乡县" },
          { v: "牧野区" },
          { v: "红旗区" },
          { v: "获嘉县" },
          { v: "辉县市" },
          { v: "长垣县" },
        ],
      },
      {
        v: "洛阳市",
        c: [
          { v: "伊川县" },
          { v: "偃师市" },
          { v: "吉利区" },
          { v: "孟津县" },
          { v: "宜阳县" },
          { v: "嵩县" },
          { v: "新安县" },
          { v: "栾川县" },
          { v: "汝阳县" },
          { v: "洛宁县" },
          { v: "洛阳新区" },
          { v: "洛龙区" },
          { v: "涧西区" },
          { v: "瀍河回族区" },
          { v: "老城区" },
          { v: "西工区" },
          { v: "高新区" },
        ],
      },
      {
        v: "济源市",
        c: [
          { v: "下冶镇" },
          { v: "五龙口镇" },
          { v: "克井镇" },
          { v: "北海街道" },
          { v: "坡头镇" },
          { v: "大峪镇" },
          { v: "天坛街道" },
          { v: "思礼镇" },
          { v: "承留镇" },
          { v: "梨林镇" },
          { v: "沁园街道" },
          { v: "济水街道" },
          { v: "玉泉街道" },
          { v: "王屋镇" },
          { v: "轵城镇" },
          { v: "邵原镇" },
        ],
      },
      { v: "漯河市", c: [{ v: "临颍县" }, { v: "召陵区" }, { v: "源汇区" }, { v: "舞阳县" }, { v: "郾城区" }] },
      { v: "濮阳市", c: [{ v: "华龙区" }, { v: "南乐县" }, { v: "台前县" }, { v: "清丰县" }, { v: "濮阳县" }, { v: "范县" }] },
      {
        v: "焦作市",
        c: [
          { v: "中站区" },
          { v: "修武县" },
          { v: "博爱县" },
          { v: "孟州市" },
          { v: "山阳区" },
          { v: "武陟县" },
          { v: "沁阳市" },
          { v: "温县" },
          { v: "解放区" },
          { v: "马村区" },
        ],
      },
      { v: "许昌市", c: [{ v: "禹州市" }, { v: "襄城县" }, { v: "许昌县" }, { v: "鄢陵县" }, { v: "长葛市" }, { v: "魏都区" }] },
      {
        v: "郑州市",
        c: [
          { v: "上街区" },
          { v: "中原区" },
          { v: "中牟县" },
          { v: "二七区" },
          { v: "巩义市" },
          { v: "惠济区" },
          { v: "新密市" },
          { v: "新郑市" },
          { v: "登封市" },
          { v: "管城回族区" },
          { v: "经济开发区" },
          { v: "荥阳市" },
          { v: "郑东新区" },
          { v: "郑汴新区" },
          { v: "金水区" },
          { v: "高新开发区" },
        ],
      },
      {
        v: "驻马店市",
        c: [
          { v: "上蔡县" },
          { v: "平舆县" },
          { v: "新蔡县" },
          { v: "正阳县" },
          { v: "汝南县" },
          { v: "泌阳县" },
          { v: "确山县" },
          { v: "西平县" },
          { v: "遂平县" },
          { v: "驿城区" },
        ],
      },
      { v: "鹤壁市", c: [{ v: "山城区" }, { v: "浚县" }, { v: "淇县" }, { v: "淇滨区" }, { v: "鹤山区" }] },
    ],
  },
  {
    v: "湖北省",
    c: [
      {
        v: "仙桃市",
        c: [
          { v: "三伏潭镇" },
          { v: "九合垸原种场" },
          { v: "五湖渔场" },
          { v: "刘家垸林场" },
          { v: "工业园区" },
          { v: "干河街道" },
          { v: "张沟镇" },
          { v: "彭场镇" },
          { v: "排湖渔场" },
          { v: "杨林尾镇" },
          { v: "毛嘴镇" },
          { v: "沔城镇" },
          { v: "沙嘴街道" },
          { v: "沙湖原种场" },
          { v: "沙湖镇" },
          { v: "畜禽良种场" },
          { v: "经济开发区" },
          { v: "胡场镇" },
          { v: "西流河镇" },
          { v: "豆河镇" },
          { v: "赵西垸林场" },
          { v: "通海口镇" },
          { v: "郑场镇" },
          { v: "郭河镇" },
          { v: "长埫口镇" },
          { v: "陈场镇" },
          { v: "高新区" },
          { v: "龙华山街道" },
        ],
      },
      {
        v: "十堰市",
        c: [{ v: "丹江口市" }, { v: "张湾区" }, { v: "房县" }, { v: "竹山县" }, { v: "竹溪县" }, { v: "茅箭区" }, { v: "郧西县" }, { v: "郧阳区" }],
      },
      { v: "咸宁市", c: [{ v: "咸安区" }, { v: "嘉鱼县" }, { v: "崇阳县" }, { v: "赤壁市" }, { v: "通城县" }, { v: "通山县" }] },
      {
        v: "天门市",
        c: [
          { v: "九真镇" },
          { v: "佛子山镇" },
          { v: "侨乡街道开发区" },
          { v: "净潭乡" },
          { v: "卢市镇" },
          { v: "多宝镇" },
          { v: "多祥镇" },
          { v: "天门工业园" },
          { v: "小板镇" },
          { v: "岳口镇" },
          { v: "干驿镇" },
          { v: "张港镇" },
          { v: "彭市镇" },
          { v: "拖市镇" },
          { v: "杨林街道" },
          { v: "横林镇" },
          { v: "汪场镇" },
          { v: "沉湖林业科技示范区" },
          { v: "渔薪镇" },
          { v: "白茅湖农场" },
          { v: "皂市镇" },
          { v: "石河镇" },
          { v: "竟陵街道" },
          { v: "胡市镇" },
          { v: "蒋场镇" },
          { v: "蒋湖农场" },
          { v: "马湾镇" },
          { v: "麻洋镇" },
          { v: "黄潭镇" },
        ],
      },
      { v: "孝感市", c: [{ v: "云梦县" }, { v: "大悟县" }, { v: "孝南区" }, { v: "孝昌县" }, { v: "安陆市" }, { v: "应城市" }, { v: "汉川市" }] },
      {
        v: "宜昌市",
        c: [
          { v: "五峰土家族自治县" },
          { v: "伍家岗区" },
          { v: "兴山县" },
          { v: "夷陵区" },
          { v: "宜昌新区" },
          { v: "宜都市" },
          { v: "当阳市" },
          { v: "枝江市" },
          { v: "点军区" },
          { v: "猇亭区" },
          { v: "秭归县" },
          { v: "西陵区" },
          { v: "远安县" },
          { v: "长阳土家族自治县" },
        ],
      },
      {
        v: "恩施土家族苗族自治州",
        c: [{ v: "利川市" }, { v: "咸丰县" }, { v: "宣恩县" }, { v: "巴东县" }, { v: "建始县" }, { v: "恩施市" }, { v: "来凤县" }, { v: "鹤峰县" }],
      },
      {
        v: "武汉市",
        c: [
          { v: "东湖高新区" },
          { v: "东西湖区" },
          { v: "新洲区" },
          { v: "武昌区" },
          { v: "汉南区" },
          { v: "汉阳区" },
          { v: "江夏区" },
          { v: "江岸区" },
          { v: "江汉区" },
          { v: "洪山区" },
          { v: "硚口区" },
          { v: "经济技术开发区" },
          { v: "蔡甸区" },
          { v: "青山区" },
          { v: "黄陂区" },
        ],
      },
      {
        v: "潜江市",
        c: [
          { v: "后湖管理区" },
          { v: "周矶" },
          { v: "周矶管理区" },
          { v: "园林" },
          { v: "广华" },
          { v: "张金镇" },
          { v: "总口管理区" },
          { v: "杨市" },
          { v: "泰丰" },
          { v: "泽口" },
          { v: "浩口镇" },
          { v: "渔洋镇" },
          { v: "熊口农场管理区" },
          { v: "熊口镇" },
          { v: "王场镇" },
          { v: "白鹭湖管理区" },
          { v: "积玉口镇" },
          { v: "竹根滩镇" },
          { v: "经济开发区" },
          { v: "老新镇" },
          { v: "运粮湖管理区" },
          { v: "高场" },
          { v: "高石碑镇" },
          { v: "龙湾镇" },
        ],
      },
      {
        v: "神农架林区",
        c: [{ v: "下谷坪乡" }, { v: "大九湖" }, { v: "宋洛" }, { v: "新华镇" }, { v: "木鱼镇" }, { v: "松柏镇" }, { v: "红坪镇" }, { v: "阳日镇" }],
      },
      {
        v: "荆州市",
        c: [{ v: "公安县" }, { v: "松滋市" }, { v: "江陵县" }, { v: "沙市区" }, { v: "洪湖市" }, { v: "监利县" }, { v: "石首市" }, { v: "荆州区" }],
      },
      { v: "荆门市", c: [{ v: "东宝区" }, { v: "京山县" }, { v: "掇刀区" }, { v: "沙洋县" }, { v: "钟祥市" }] },
      {
        v: "襄阳市",
        c: [
          { v: "保康县" },
          { v: "南漳县" },
          { v: "宜城市" },
          { v: "枣阳市" },
          { v: "樊城区" },
          { v: "经济开发区" },
          { v: "老河口市" },
          { v: "襄城区" },
          { v: "襄州区" },
          { v: "谷城县" },
          { v: "高新区" },
        ],
      },
      { v: "鄂州市", c: [{ v: "华容区" }, { v: "梁子湖区" }, { v: "鄂城区" }] },
      { v: "随州市", c: [{ v: "广水市" }, { v: "曾都区" }, { v: "随县" }] },
      {
        v: "黄冈市",
        c: [
          { v: "团风县" },
          { v: "武穴市" },
          { v: "浠水县" },
          { v: "红安县" },
          { v: "罗田县" },
          { v: "英山县" },
          { v: "蕲春县" },
          { v: "麻城市" },
          { v: "黄州区" },
          { v: "黄梅县" },
        ],
      },
      { v: "黄石市", c: [{ v: "下陆区" }, { v: "大冶市" }, { v: "经济开发区" }, { v: "西塞山区" }, { v: "铁山区" }, { v: "阳新县" }, { v: "黄石港区" }] },
    ],
  },
  {
    v: "湖南省",
    c: [
      { v: "娄底市", c: [{ v: "冷水江市" }, { v: "双峰县" }, { v: "娄星区" }, { v: "新化县" }, { v: "涟源市" }] },
      {
        v: "岳阳市",
        c: [
          { v: "临湘市" },
          { v: "云溪区" },
          { v: "华容县" },
          { v: "君山区" },
          { v: "岳阳县" },
          { v: "岳阳楼区" },
          { v: "平江县" },
          { v: "汨罗市" },
          { v: "湘阴县" },
        ],
      },
      {
        v: "常德市",
        c: [
          { v: "临澧县" },
          { v: "安乡县" },
          { v: "桃源县" },
          { v: "武陵区" },
          { v: "汉寿县" },
          { v: "津市市" },
          { v: "澧县" },
          { v: "石门县" },
          { v: "鼎城区" },
        ],
      },
      { v: "张家界市", c: [{ v: "慈利县" }, { v: "桑植县" }, { v: "武陵源区" }, { v: "永定区" }] },
      {
        v: "怀化市",
        c: [
          { v: "中方县" },
          { v: "会同县" },
          { v: "新晃侗族自治县" },
          { v: "沅陵县" },
          { v: "洪江市" },
          { v: "溆浦县" },
          { v: "芷江侗族自治县" },
          { v: "辰溪县" },
          { v: "通道侗族自治县" },
          { v: "靖州苗族侗族自治县" },
          { v: "鹤城区" },
          { v: "麻阳苗族自治县" },
        ],
      },
      {
        v: "株洲市",
        c: [
          { v: "天元区" },
          { v: "攸县" },
          { v: "株洲县" },
          { v: "炎陵县" },
          { v: "石峰区" },
          { v: "芦淞区" },
          { v: "茶陵县" },
          { v: "荷塘区" },
          { v: "醴陵市" },
        ],
      },
      {
        v: "永州市",
        c: [
          { v: "东安县" },
          { v: "冷水滩区" },
          { v: "双牌县" },
          { v: "宁远县" },
          { v: "新田县" },
          { v: "江华瑶族自治县" },
          { v: "江永县" },
          { v: "祁阳县" },
          { v: "蓝山县" },
          { v: "道县" },
          { v: "零陵区" },
        ],
      },
      { v: "湘潭市", c: [{ v: "岳塘区" }, { v: "湘乡市" }, { v: "湘潭县" }, { v: "雨湖区" }, { v: "韶山市" }, { v: "高新区" }] },
      {
        v: "湘西土家族苗族自治州",
        c: [{ v: "保靖县" }, { v: "凤凰县" }, { v: "古丈县" }, { v: "吉首市" }, { v: "永顺县" }, { v: "泸溪县" }, { v: "花垣县" }, { v: "龙山县" }],
      },
      { v: "益阳市", c: [{ v: "南县" }, { v: "安化县" }, { v: "桃江县" }, { v: "沅江市" }, { v: "资阳区" }, { v: "赫山区" }] },
      {
        v: "衡阳市",
        c: [
          { v: "南岳区" },
          { v: "常宁市" },
          { v: "珠晖区" },
          { v: "石鼓区" },
          { v: "祁东县" },
          { v: "耒阳市" },
          { v: "蒸湘区" },
          { v: "衡东县" },
          { v: "衡南县" },
          { v: "衡山县" },
          { v: "衡阳县" },
          { v: "雁峰区" },
        ],
      },
      {
        v: "邵阳市",
        c: [
          { v: "北塔区" },
          { v: "双清区" },
          { v: "城步苗族自治县" },
          { v: "大祥区" },
          { v: "新宁县" },
          { v: "新邵县" },
          { v: "武冈市" },
          { v: "洞口县" },
          { v: "绥宁县" },
          { v: "邵东县" },
          { v: "邵阳县" },
          { v: "隆回县" },
        ],
      },
      {
        v: "郴州市",
        c: [
          { v: "临武县" },
          { v: "北湖区" },
          { v: "嘉禾县" },
          { v: "安仁县" },
          { v: "宜章县" },
          { v: "桂东县" },
          { v: "桂阳县" },
          { v: "永兴县" },
          { v: "汝城县" },
          { v: "苏仙区" },
          { v: "资兴市" },
        ],
      },
      {
        v: "长沙市",
        c: [
          { v: "天心区" },
          { v: "宁乡县" },
          { v: "岳麓区" },
          { v: "开福区" },
          { v: "望城区" },
          { v: "浏阳市" },
          { v: "湘江新区" },
          { v: "芙蓉区" },
          { v: "长沙县" },
          { v: "雨花区" },
        ],
      },
    ],
  },
  {
    v: "广东省",
    c: [
      {
        v: "东莞市",
        c: [
          { v: "万江区" },
          { v: "东坑镇" },
          { v: "东城区" },
          { v: "中堂镇" },
          { v: "企石镇" },
          { v: "凤岗镇" },
          { v: "南城区" },
          { v: "厚街镇" },
          { v: "塘厦镇" },
          { v: "大岭山镇" },
          { v: "大朗镇" },
          { v: "寮步镇" },
          { v: "常平镇" },
          { v: "望牛墩镇" },
          { v: "松山湖高新区" },
          { v: "桥头镇" },
          { v: "樟木头镇" },
          { v: "横沥镇" },
          { v: "沙田镇" },
          { v: "洪梅镇" },
          { v: "清溪镇" },
          { v: "石排镇" },
          { v: "石碣镇" },
          { v: "石龙镇" },
          { v: "茶山镇" },
          { v: "莞城区" },
          { v: "虎门镇" },
          { v: "谢岗镇" },
          { v: "道滘镇" },
          { v: "长安镇" },
          { v: "高埗镇" },
          { v: "麻涌镇" },
          { v: "黄江镇" },
        ],
      },
      {
        v: "中山市",
        c: [
          { v: "三乡镇" },
          { v: "三角镇" },
          { v: "东凤镇" },
          { v: "东区" },
          { v: "东升镇" },
          { v: "五桂山区" },
          { v: "南区" },
          { v: "南头镇" },
          { v: "南朗镇" },
          { v: "古镇镇" },
          { v: "坦洲镇" },
          { v: "大涌镇" },
          { v: "小榄镇" },
          { v: "板芙镇" },
          { v: "横栏镇" },
          { v: "民众镇" },
          { v: "沙溪镇" },
          { v: "港口镇" },
          { v: "火炬开发区" },
          { v: "石岐区" },
          { v: "神湾镇" },
          { v: "西区" },
          { v: "阜沙镇" },
          { v: "黄圃镇" },
        ],
      },
      { v: "云浮市", c: [{ v: "云城区" }, { v: "云安区" }, { v: "新兴县" }, { v: "罗定市" }, { v: "郁南县" }] },
      { v: "佛山市", c: [{ v: "三水区" }, { v: "南海区" }, { v: "禅城区" }, { v: "顺德区" }, { v: "高明区" }] },
      {
        v: "广州市",
        c: [
          { v: "从化区" },
          { v: "南沙新区" },
          { v: "增城区" },
          { v: "天河区" },
          { v: "海珠区" },
          { v: "番禺区" },
          { v: "白云区" },
          { v: "花都区" },
          { v: "荔湾区" },
          { v: "越秀区" },
          { v: "黄埔区" },
        ],
      },
      { v: "惠州市", c: [{ v: "博罗县" }, { v: "大亚湾区" }, { v: "惠东县" }, { v: "惠城区" }, { v: "惠阳区" }, { v: "龙门县" }] },
      { v: "揭阳市", c: [{ v: "惠来县" }, { v: "揭东区" }, { v: "揭西县" }, { v: "普宁市" }, { v: "榕城区" }] },
      {
        v: "梅州市",
        c: [{ v: "丰顺县" }, { v: "五华县" }, { v: "兴宁市" }, { v: "大埔县" }, { v: "平远县" }, { v: "梅县区" }, { v: "梅江区" }, { v: "蕉岭县" }],
      },
      { v: "汕头市", c: [{ v: "南澳县" }, { v: "潮南区" }, { v: "潮阳区" }, { v: "澄海区" }, { v: "濠江区" }, { v: "金平区" }, { v: "龙湖区" }] },
      { v: "汕尾市", c: [{ v: "城区" }, { v: "海丰县" }, { v: "陆丰市" }, { v: "陆河县" }] },
      { v: "江门市", c: [{ v: "台山市" }, { v: "开平市" }, { v: "恩平市" }, { v: "新会区" }, { v: "江海区" }, { v: "蓬江区" }, { v: "鹤山市" }] },
      { v: "河源市", c: [{ v: "东源县" }, { v: "和平县" }, { v: "源城区" }, { v: "紫金县" }, { v: "连平县" }, { v: "龙川县" }] },
      {
        v: "深圳市",
        c: [
          { v: "光明新区" },
          { v: "南山区" },
          { v: "坪山区" },
          { v: "大鹏新区" },
          { v: "宝安区" },
          { v: "盐田区" },
          { v: "福田区" },
          { v: "罗湖区" },
          { v: "龙华区" },
          { v: "龙岗区" },
        ],
      },
      {
        v: "清远市",
        c: [
          { v: "佛冈县" },
          { v: "清城区" },
          { v: "清新区" },
          { v: "英德市" },
          { v: "连南瑶族自治县" },
          { v: "连山壮族瑶族自治县" },
          { v: "连州市" },
          { v: "阳山县" },
        ],
      },
      {
        v: "湛江市",
        c: [
          { v: "吴川市" },
          { v: "坡头区" },
          { v: "廉江市" },
          { v: "徐闻县" },
          { v: "经济开发区" },
          { v: "赤坎区" },
          { v: "遂溪县" },
          { v: "雷州市" },
          { v: "霞山区" },
          { v: "麻章区" },
        ],
      },
      { v: "潮州市", c: [{ v: "湘桥区" }, { v: "潮安区" }, { v: "饶平县" }] },
      { v: "珠海市", c: [{ v: "斗门区" }, { v: "横琴新区" }, { v: "经济开发区" }, { v: "金湾区" }, { v: "香洲区" }] },
      {
        v: "肇庆市",
        c: [{ v: "四会市" }, { v: "封开县" }, { v: "广宁县" }, { v: "德庆县" }, { v: "怀集县" }, { v: "端州区" }, { v: "高要区" }, { v: "鼎湖区" }],
      },
      { v: "茂名市", c: [{ v: "信宜市" }, { v: "化州市" }, { v: "电白区" }, { v: "茂南区" }, { v: "高州市" }] },
      { v: "阳江市", c: [{ v: "江城区" }, { v: "阳东区" }, { v: "阳春市" }, { v: "阳西县" }] },
      {
        v: "韶关市",
        c: [
          { v: "乐昌市" },
          { v: "乳源瑶族自治县" },
          { v: "仁化县" },
          { v: "南雄市" },
          { v: "始兴县" },
          { v: "新丰县" },
          { v: "曲江区" },
          { v: "武江区" },
          { v: "浈江区" },
          { v: "翁源县" },
        ],
      },
    ],
  },
  {
    v: "广西壮族自治区",
    c: [
      { v: "北海市", c: [{ v: "合浦县" }, { v: "海城区" }, { v: "铁山港区" }, { v: "银海区" }] },
      {
        v: "南宁市",
        c: [
          { v: "上林县" },
          { v: "兴宁区" },
          { v: "埌东新区" },
          { v: "宾阳县" },
          { v: "横县" },
          { v: "武鸣区" },
          { v: "江南区" },
          { v: "良庆区" },
          { v: "西乡塘区" },
          { v: "邕宁区" },
          { v: "隆安县" },
          { v: "青秀区" },
          { v: "马山县" },
        ],
      },
      { v: "崇左市", c: [{ v: "凭祥市" }, { v: "大新县" }, { v: "天等县" }, { v: "宁明县" }, { v: "扶绥县" }, { v: "江州区" }, { v: "龙州县" }] },
      { v: "来宾市", c: [{ v: "兴宾区" }, { v: "合山市" }, { v: "忻城县" }, { v: "武宣县" }, { v: "象州县" }, { v: "金秀瑶族自治县" }] },
      {
        v: "柳州市",
        c: [
          { v: "三江侗族自治县" },
          { v: "城中区" },
          { v: "柳东新区" },
          { v: "柳北区" },
          { v: "柳南区" },
          { v: "柳城县" },
          { v: "柳江区" },
          { v: "融安县" },
          { v: "融水苗族自治县" },
          { v: "鱼峰区" },
          { v: "鹿寨县" },
        ],
      },
      {
        v: "桂林市",
        c: [
          { v: "七星区" },
          { v: "临桂区" },
          { v: "全州县" },
          { v: "兴安县" },
          { v: "叠彩区" },
          { v: "平乐县" },
          { v: "恭城瑶族自治县" },
          { v: "永福县" },
          { v: "灌阳县" },
          { v: "灵川县" },
          { v: "秀峰区" },
          { v: "荔浦县" },
          { v: "象山区" },
          { v: "资源县" },
          { v: "阳朔县" },
          { v: "雁山区" },
          { v: "龙胜各族自治县" },
        ],
      },
      { v: "梧州市", c: [{ v: "万秀区" }, { v: "岑溪市" }, { v: "苍梧县" }, { v: "蒙山县" }, { v: "藤县" }, { v: "长洲区" }, { v: "龙圩区" }] },
      {
        v: "河池市",
        c: [
          { v: "东兰县" },
          { v: "凤山县" },
          { v: "南丹县" },
          { v: "大化瑶族自治县" },
          { v: "天峨县" },
          { v: "宜州市" },
          { v: "巴马瑶族自治县" },
          { v: "环江毛南族自治县" },
          { v: "罗城仫佬族自治县" },
          { v: "都安瑶族自治县" },
          { v: "金城江区" },
        ],
      },
      {
        v: "玉林市",
        c: [{ v: "兴业县" }, { v: "北流市" }, { v: "博白县" }, { v: "容县" }, { v: "玉东新区" }, { v: "玉州区" }, { v: "福绵区" }, { v: "陆川县" }],
      },
      {
        v: "百色市",
        c: [
          { v: "乐业县" },
          { v: "凌云县" },
          { v: "右江区" },
          { v: "平果县" },
          { v: "德保县" },
          { v: "田东县" },
          { v: "田林县" },
          { v: "田阳县" },
          { v: "西林县" },
          { v: "那坡县" },
          { v: "隆林各族自治县" },
          { v: "靖西市" },
        ],
      },
      { v: "贵港市", c: [{ v: "平南县" }, { v: "桂平市" }, { v: "港北区" }, { v: "港南区" }, { v: "覃塘区" }] },
      { v: "贺州市", c: [{ v: "八步区" }, { v: "富川瑶族自治县" }, { v: "平桂区" }, { v: "昭平县" }, { v: "钟山县" }] },
      { v: "钦州市", c: [{ v: "浦北县" }, { v: "灵山县" }, { v: "钦北区" }, { v: "钦南区" }] },
      { v: "防城港市", c: [{ v: "上思县" }, { v: "东兴市" }, { v: "港口区" }, { v: "防城区" }] },
    ],
  },
  {
    v: "海南省",
    c: [
      {
        v: "万宁市",
        c: [
          { v: "万城镇" },
          { v: "三更罗镇" },
          { v: "东兴农场" },
          { v: "东和农场" },
          { v: "东岭农场" },
          { v: "东澳镇" },
          { v: "兴隆华侨农场" },
          { v: "北大镇" },
          { v: "南林农场" },
          { v: "南桥镇" },
          { v: "后安镇" },
          { v: "和乐镇" },
          { v: "大茂镇" },
          { v: "山根镇" },
          { v: "新中农场" },
          { v: "礼纪镇" },
          { v: "长丰镇" },
          { v: "龙滚镇" },
        ],
      },
      { v: "三亚市", c: [{ v: "吉阳区" }, { v: "天涯区" }, { v: "崖州区" }, { v: "海棠区" }] },
      { v: "三沙市", c: [{ v: "中沙群岛" }, { v: "南沙群岛" }, { v: "西沙群岛" }] },
      {
        v: "东方市",
        c: [
          { v: "三家镇" },
          { v: "东方华侨农场" },
          { v: "东河镇" },
          { v: "八所镇" },
          { v: "四更镇" },
          { v: "大田镇" },
          { v: "天安乡" },
          { v: "广坝农场" },
          { v: "感城镇" },
          { v: "新龙镇" },
          { v: "板桥镇" },
          { v: "江边乡" },
        ],
      },
      {
        v: "临高县",
        c: [
          { v: "东英镇" },
          { v: "临城镇" },
          { v: "加来农场" },
          { v: "加来镇" },
          { v: "南宝镇" },
          { v: "博厚镇" },
          { v: "和舍镇" },
          { v: "城区" },
          { v: "多文镇" },
          { v: "新盈镇" },
          { v: "波莲镇" },
          { v: "皇桐镇" },
          { v: "红华农场" },
          { v: "调楼镇" },
        ],
      },
      {
        v: "乐东黎族自治县",
        c: [
          { v: "万冲镇" },
          { v: "乐中农场" },
          { v: "乐光农场" },
          { v: "九所镇" },
          { v: "佛罗镇" },
          { v: "保国农场" },
          { v: "保显农场" },
          { v: "利国镇" },
          { v: "千家镇" },
          { v: "城区" },
          { v: "大安镇" },
          { v: "尖峰岭林业" },
          { v: "尖峰镇" },
          { v: "山荣农场" },
          { v: "志仲镇" },
          { v: "报伦农场" },
          { v: "抱由镇" },
          { v: "福报农场" },
          { v: "莺歌海盐场" },
          { v: "莺歌海镇" },
          { v: "黄流镇" },
        ],
      },
      { v: "五指山市", c: [{ v: "南圣镇" }, { v: "毛道乡" }, { v: "毛阳镇" }, { v: "水满乡" }, { v: "畅好乡" }, { v: "番阳镇" }, { v: "通什镇" }] },
      {
        v: "保亭黎族苗族自治县",
        c: [
          { v: "三道农场" },
          { v: "三道镇" },
          { v: "什玲镇" },
          { v: "保城镇" },
          { v: "六弓乡" },
          { v: "加茂镇" },
          { v: "南林乡" },
          { v: "响水镇" },
          { v: "新政镇" },
          { v: "新星农场" },
          { v: "毛感乡" },
          { v: "金江农场" },
        ],
      },
      {
        v: "儋州市",
        c: [
          { v: "三都镇" },
          { v: "东成镇" },
          { v: "中和镇" },
          { v: "光村镇" },
          { v: "八一农场" },
          { v: "兰洋镇" },
          { v: "南丰镇" },
          { v: "和庆镇" },
          { v: "大成镇" },
          { v: "峨蔓镇" },
          { v: "排浦镇" },
          { v: "新州镇" },
          { v: "新盈农场" },
          { v: "木棠镇" },
          { v: "洋浦经济开发区" },
          { v: "海头镇" },
          { v: "王五镇" },
          { v: "白马井镇" },
          { v: "红岭农场" },
          { v: "蓝洋农场" },
          { v: "西华农场" },
          { v: "西培农场" },
          { v: "西庆农场" },
          { v: "西流农场" },
          { v: "西联农场" },
          { v: "那大镇" },
          { v: "雅星镇" },
          { v: "龙山农场" },
        ],
      },
      {
        v: "定安县",
        c: [
          { v: "中瑞农场" },
          { v: "南海农场" },
          { v: "城区" },
          { v: "定城镇" },
          { v: "富文镇" },
          { v: "岭口镇" },
          { v: "新竹镇" },
          { v: "翰林镇" },
          { v: "金鸡岭农场" },
          { v: "雷鸣镇" },
          { v: "黄竹镇" },
          { v: "龙河镇" },
          { v: "龙湖镇" },
          { v: "龙门镇" },
        ],
      },
      {
        v: "屯昌县",
        c: [
          { v: "中坤农场" },
          { v: "中建农场" },
          { v: "乌坡镇" },
          { v: "南吕镇" },
          { v: "南坤镇" },
          { v: "县城内" },
          { v: "坡心镇" },
          { v: "屯城镇" },
          { v: "新兴镇" },
          { v: "枫木镇" },
          { v: "西昌镇" },
        ],
      },
      {
        v: "文昌市",
        c: [
          { v: "东路农场" },
          { v: "东路镇" },
          { v: "东郊镇" },
          { v: "东阁镇" },
          { v: "会文镇" },
          { v: "公坡镇" },
          { v: "冯坡镇" },
          { v: "南阳农场" },
          { v: "南阳镇" },
          { v: "头苑镇" },
          { v: "宝芳乡" },
          { v: "抱罗镇" },
          { v: "文城镇" },
          { v: "文教镇" },
          { v: "新桥镇" },
          { v: "昌洒镇" },
          { v: "清谰镇" },
          { v: "湖山乡" },
          { v: "潭牛镇" },
          { v: "罗豆农场" },
          { v: "翁田镇" },
          { v: "蓬莱镇" },
          { v: "迈号镇" },
          { v: "重兴镇" },
          { v: "铺前镇" },
          { v: "锦山镇" },
          { v: "龙楼镇" },
          { v: "龙马乡" },
        ],
      },
      {
        v: "昌江黎族自治县",
        c: [
          { v: "七叉镇" },
          { v: "乌烈镇" },
          { v: "保平乡" },
          { v: "十月田镇" },
          { v: "南罗镇" },
          { v: "叉河镇" },
          { v: "城区" },
          { v: "太坡镇" },
          { v: "昌化镇" },
          { v: "昌城乡" },
          { v: "海尾镇" },
          { v: "王下乡" },
          { v: "石碌镇" },
          { v: "红林农场" },
          { v: "霸王岭林场" },
        ],
      },
      { v: "海口市", c: [{ v: "琼山区" }, { v: "秀英区" }, { v: "美兰区" }, { v: "龙华区" }] },
      {
        v: "澄迈县",
        c: [
          { v: "中兴镇" },
          { v: "仁兴镇" },
          { v: "加乐镇" },
          { v: "城区" },
          { v: "大丰镇" },
          { v: "文儒镇" },
          { v: "桥头镇" },
          { v: "永发镇" },
          { v: "瑞溪镇" },
          { v: "福山镇" },
          { v: "红光农场" },
          { v: "老城镇" },
          { v: "西达农场" },
          { v: "金安农场" },
          { v: "金江镇" },
        ],
      },
      {
        v: "琼中黎族苗族自治县",
        c: [
          { v: "上安乡" },
          { v: "中平镇" },
          { v: "乌石农场" },
          { v: "什运乡" },
          { v: "加钗农场" },
          { v: "吊罗山乡" },
          { v: "和平镇" },
          { v: "城区" },
          { v: "湾岭镇" },
          { v: "红毛镇" },
          { v: "营根镇" },
          { v: "长征农场" },
          { v: "长征镇" },
          { v: "阳江农场" },
          { v: "黎母山镇" },
        ],
      },
      {
        v: "琼海市",
        c: [
          { v: "万泉镇" },
          { v: "东升农场" },
          { v: "东太农场" },
          { v: "东红农场" },
          { v: "中原镇" },
          { v: "会山镇" },
          { v: "南俸农场" },
          { v: "博鳌镇" },
          { v: "嘉积镇" },
          { v: "塔洋镇" },
          { v: "大路镇" },
          { v: "彬村山华侨农场" },
          { v: "潭门镇" },
          { v: "石壁镇" },
          { v: "长坡镇" },
          { v: "阳江镇" },
          { v: "龙江镇" },
        ],
      },
      {
        v: "白沙黎族自治县",
        c: [
          { v: "七坊镇" },
          { v: "元门乡" },
          { v: "南开乡" },
          { v: "城区" },
          { v: "打安镇" },
          { v: "牙叉镇" },
          { v: "白沙农场" },
          { v: "细水乡" },
          { v: "荣邦乡" },
          { v: "邦溪农场" },
          { v: "邦溪镇" },
          { v: "金波乡" },
          { v: "阜龙乡" },
          { v: "青松乡" },
          { v: "龙江农场" },
        ],
      },
      {
        v: "陵水黎族自治县",
        c: [
          { v: "三才镇" },
          { v: "光坡镇" },
          { v: "南平农场" },
          { v: "城区" },
          { v: "岭门农场" },
          { v: "提蒙乡" },
          { v: "文罗镇" },
          { v: "新村镇" },
          { v: "本号镇" },
          { v: "椰林镇" },
          { v: "群英乡" },
          { v: "英州镇" },
          { v: "隆广镇" },
          { v: "黎安镇" },
        ],
      },
    ],
  },
  {
    v: "重庆市",
    c: [
      {
        v: "市辖区",
        c: [
          { v: "万州区" },
          { v: "两江新区" },
          { v: "丰都县" },
          { v: "九龙坡区" },
          { v: "云阳县" },
          { v: "北碚区" },
          { v: "南岸区" },
          { v: "南川区" },
          { v: "合川区" },
          { v: "垫江县" },
          { v: "城口县" },
          { v: "大渡口区" },
          { v: "大足区" },
          { v: "奉节县" },
          { v: "巫山县" },
          { v: "巫溪县" },
          { v: "巴南区" },
          { v: "开州区" },
          { v: "彭水苗族土家族自治县" },
          { v: "忠县" },
          { v: "梁平区" },
          { v: "武隆区" },
          { v: "永川区" },
          { v: "江北区" },
          { v: "江津区" },
          { v: "沙坪坝区" },
          { v: "涪陵区" },
          { v: "渝中区" },
          { v: "渝北区" },
          { v: "潼南区" },
          { v: "璧山区" },
          { v: "璧山高新区" },
          { v: "石柱土家族自治县" },
          { v: "秀山土家族苗族自治县" },
          { v: "綦江区" },
          { v: "荣昌区" },
          { v: "酉阳土家族苗族自治县" },
          { v: "铜梁区" },
          { v: "长寿区" },
          { v: "高新区" },
          { v: "黔江区" },
        ],
      },
    ],
  },
  {
    v: "四川省",
    c: [
      {
        v: "乐山市",
        c: [
          { v: "五通桥区" },
          { v: "井研县" },
          { v: "夹江县" },
          { v: "峨眉山市" },
          { v: "峨边彝族自治县" },
          { v: "市中区" },
          { v: "沐川县" },
          { v: "沙湾区" },
          { v: "犍为县" },
          { v: "金口河区" },
          { v: "马边彝族自治县" },
        ],
      },
      { v: "内江市", c: [{ v: "东兴区" }, { v: "威远县" }, { v: "市中区" }, { v: "资中县" }, { v: "隆昌县" }] },
      {
        v: "凉山彝族自治州",
        c: [
          { v: "会东县" },
          { v: "会理县" },
          { v: "冕宁县" },
          { v: "喜德县" },
          { v: "宁南县" },
          { v: "布拖县" },
          { v: "德昌县" },
          { v: "昭觉县" },
          { v: "普格县" },
          { v: "木里藏族自治县" },
          { v: "甘洛县" },
          { v: "盐源县" },
          { v: "美姑县" },
          { v: "西昌市" },
          { v: "越西县" },
          { v: "金阳县" },
          { v: "雷波县" },
        ],
      },
      {
        v: "南充市",
        c: [
          { v: "仪陇县" },
          { v: "南部县" },
          { v: "嘉陵区" },
          { v: "营山县" },
          { v: "蓬安县" },
          { v: "西充县" },
          { v: "阆中市" },
          { v: "顺庆区" },
          { v: "高坪区" },
        ],
      },
      {
        v: "宜宾市",
        c: [
          { v: "兴文县" },
          { v: "南溪区" },
          { v: "宜宾县" },
          { v: "屏山县" },
          { v: "江安县" },
          { v: "珙县" },
          { v: "筠连县" },
          { v: "翠屏区" },
          { v: "长宁县" },
          { v: "高县" },
        ],
      },
      { v: "巴中市", c: [{ v: "南江县" }, { v: "巴州区" }, { v: "平昌县" }, { v: "恩阳区" }, { v: "通江县" }] },
      { v: "广元市", c: [{ v: "利州区" }, { v: "剑阁县" }, { v: "旺苍县" }, { v: "昭化区" }, { v: "朝天区" }, { v: "苍溪县" }, { v: "青川县" }] },
      { v: "广安市", c: [{ v: "前锋区" }, { v: "华蓥市" }, { v: "岳池县" }, { v: "广安区" }, { v: "武胜县" }, { v: "邻水县" }] },
      { v: "德阳市", c: [{ v: "中江县" }, { v: "什邡市" }, { v: "广汉市" }, { v: "旌阳区" }, { v: "绵竹市" }, { v: "罗江县" }] },
      {
        v: "成都市",
        c: [
          { v: "双流区" },
          { v: "大邑县" },
          { v: "天府新区" },
          { v: "崇州市" },
          { v: "彭州市" },
          { v: "成华区" },
          { v: "新津县" },
          { v: "新都区" },
          { v: "武侯区" },
          { v: "温江区" },
          { v: "简阳市" },
          { v: "蒲江县" },
          { v: "邛崃市" },
          { v: "郫都区" },
          { v: "都江堰市" },
          { v: "金堂县" },
          { v: "金牛区" },
          { v: "锦江区" },
          { v: "青白江区" },
          { v: "青羊区" },
          { v: "高新南区" },
          { v: "高新西区" },
          { v: "龙泉驿区" },
        ],
      },
      { v: "攀枝花市", c: [{ v: "东区" }, { v: "仁和区" }, { v: "盐边县" }, { v: "米易县" }, { v: "西区" }] },
      { v: "泸州市", c: [{ v: "叙永县" }, { v: "古蔺县" }, { v: "合江县" }, { v: "江阳区" }, { v: "泸县" }, { v: "纳溪区" }, { v: "龙马潭区" }] },
      {
        v: "甘孜藏族自治州",
        c: [
          { v: "丹巴县" },
          { v: "九龙县" },
          { v: "乡城县" },
          { v: "巴塘县" },
          { v: "康定市" },
          { v: "得荣县" },
          { v: "德格县" },
          { v: "新龙县" },
          { v: "泸定县" },
          { v: "炉霍县" },
          { v: "理塘县" },
          { v: "甘孜县" },
          { v: "白玉县" },
          { v: "石渠县" },
          { v: "稻城县" },
          { v: "色达县" },
          { v: "道孚县" },
          { v: "雅江县" },
        ],
      },
      { v: "眉山市", c: [{ v: "东坡区" }, { v: "丹棱县" }, { v: "仁寿县" }, { v: "彭山区" }, { v: "洪雅县" }, { v: "青神县" }] },
      {
        v: "绵阳市",
        c: [
          { v: "三台县" },
          { v: "北川羌族自治县" },
          { v: "安州区" },
          { v: "平武县" },
          { v: "梓潼县" },
          { v: "江油市" },
          { v: "涪城区" },
          { v: "游仙区" },
          { v: "盐亭县" },
          { v: "经开区" },
          { v: "高新区" },
        ],
      },
      { v: "自贡市", c: [{ v: "大安区" }, { v: "富顺县" }, { v: "沿滩区" }, { v: "自流井区" }, { v: "荣县" }, { v: "贡井区" }] },
      { v: "资阳市", c: [{ v: "乐至县" }, { v: "安岳县" }, { v: "雁江区" }] },
      { v: "达州市", c: [{ v: "万源市" }, { v: "大竹县" }, { v: "宣汉县" }, { v: "开江县" }, { v: "渠县" }, { v: "达川区" }, { v: "通川区" }] },
      { v: "遂宁市", c: [{ v: "大英县" }, { v: "安居区" }, { v: "射洪县" }, { v: "经济技术开发区" }, { v: "船山区" }, { v: "蓬溪县" }] },
      {
        v: "阿坝藏族羌族自治州",
        c: [
          { v: "九寨沟县" },
          { v: "壤塘县" },
          { v: "小金县" },
          { v: "松潘县" },
          { v: "汶川县" },
          { v: "理县" },
          { v: "红原县" },
          { v: "若尔盖县" },
          { v: "茂县" },
          { v: "金川县" },
          { v: "阿坝县" },
          { v: "马尔康市" },
          { v: "黑水县" },
        ],
      },
      {
        v: "雅安市",
        c: [{ v: "名山区" }, { v: "天全县" }, { v: "宝兴县" }, { v: "汉源县" }, { v: "石棉县" }, { v: "芦山县" }, { v: "荥经县" }, { v: "雨城区" }],
      },
    ],
  },
  {
    v: "贵州省",
    c: [
      { v: "六盘水市", c: [{ v: "六枝特区" }, { v: "水城县" }, { v: "盘县" }, { v: "钟山区" }] },
      {
        v: "安顺市",
        c: [{ v: "关岭布依族苗族自治县" }, { v: "平坝区" }, { v: "普定县" }, { v: "紫云苗族布依族自治县" }, { v: "西秀区" }, { v: "镇宁布依族苗族自治县" }],
      },
      {
        v: "毕节市",
        c: [
          { v: "七星关区" },
          { v: "大方县" },
          { v: "威宁彝族回族苗族自治县" },
          { v: "纳雍县" },
          { v: "织金县" },
          { v: "赫章县" },
          { v: "金沙县" },
          { v: "黔西县" },
        ],
      },
      {
        v: "贵阳市",
        c: [
          { v: "乌当区" },
          { v: "云岩区" },
          { v: "修文县" },
          { v: "南明区" },
          { v: "开阳县" },
          { v: "息烽县" },
          { v: "清镇市" },
          { v: "白云区" },
          { v: "花溪区" },
          { v: "观山湖区" },
          { v: "贵安新区" },
          { v: "高新区" },
        ],
      },
      {
        v: "遵义市",
        c: [
          { v: "习水县" },
          { v: "仁怀市" },
          { v: "余庆县" },
          { v: "凤冈县" },
          { v: "务川仡佬族苗族自治县" },
          { v: "播州区" },
          { v: "桐梓县" },
          { v: "正安县" },
          { v: "汇川区" },
          { v: "湄潭县" },
          { v: "红花岗区" },
          { v: "绥阳县" },
          { v: "赤水市" },
          { v: "道真仡佬族苗族自治县" },
        ],
      },
      {
        v: "铜仁市",
        c: [
          { v: "万山区" },
          { v: "印江土家族苗族自治县" },
          { v: "德江县" },
          { v: "思南县" },
          { v: "松桃苗族自治县" },
          { v: "江口县" },
          { v: "沿河土家族自治县" },
          { v: "玉屏侗族自治县" },
          { v: "石阡县" },
          { v: "碧江区" },
        ],
      },
      {
        v: "黔东南苗族侗族自治州",
        c: [
          { v: "三穗县" },
          { v: "丹寨县" },
          { v: "从江县" },
          { v: "凯里市" },
          { v: "剑河县" },
          { v: "台江县" },
          { v: "天柱县" },
          { v: "岑巩县" },
          { v: "施秉县" },
          { v: "榕江县" },
          { v: "锦屏县" },
          { v: "镇远县" },
          { v: "雷山县" },
          { v: "麻江县" },
          { v: "黄平县" },
          { v: "黎平县" },
        ],
      },
      {
        v: "黔南布依族苗族自治州",
        c: [
          { v: "三都水族自治县" },
          { v: "平塘县" },
          { v: "惠水县" },
          { v: "独山县" },
          { v: "瓮安县" },
          { v: "福泉市" },
          { v: "罗甸县" },
          { v: "荔波县" },
          { v: "贵定县" },
          { v: "都匀市" },
          { v: "长顺县" },
          { v: "龙里县" },
        ],
      },
      {
        v: "黔西南布依族苗族自治州",
        c: [{ v: "兴义市 " }, { v: "兴仁县" }, { v: "册亨县" }, { v: "安龙县" }, { v: "普安县" }, { v: "晴隆县" }, { v: "望谟县" }, { v: "贞丰县" }],
      },
    ],
  },
  {
    v: "云南省",
    c: [
      {
        v: "临沧市",
        c: [
          { v: "临翔区" },
          { v: "云县" },
          { v: "凤庆县" },
          { v: "双江拉祜族佤族布朗族傣族自治县" },
          { v: "永德县" },
          { v: "沧源佤族自治县" },
          { v: "耿马傣族佤族自治县" },
          { v: "镇康县" },
        ],
      },
      { v: "丽江市", c: [{ v: "华坪县" }, { v: "古城区" }, { v: "宁蒗彝族自治县" }, { v: "永胜县" }, { v: "玉龙纳西族自治县" }] },
      { v: "保山市", c: [{ v: "施甸县" }, { v: "昌宁县" }, { v: "腾冲市" }, { v: "隆阳区" }, { v: "龙陵县" }] },
      {
        v: "大理白族自治州",
        c: [
          { v: "云龙县" },
          { v: "剑川县" },
          { v: "南涧彝族自治县" },
          { v: "大理市" },
          { v: "宾川县" },
          { v: "巍山彝族回族自治县" },
          { v: "弥渡县" },
          { v: "永平县" },
          { v: "洱源县" },
          { v: "漾濞彝族自治县" },
          { v: "祥云县" },
          { v: "鹤庆县" },
        ],
      },
      { v: "德宏傣族景颇族自治州", c: [{ v: "梁河县" }, { v: "瑞丽市" }, { v: "盈江县" }, { v: "芒市" }, { v: "陇川县" }] },
      { v: "怒江傈僳族自治州", c: [{ v: "兰坪白族普米族自治县" }, { v: "泸水市" }, { v: "福贡县" }, { v: "贡山独龙族怒族自治县" }] },
      {
        v: "文山壮族苗族自治州",
        c: [{ v: "丘北县" }, { v: "富宁县" }, { v: "广南县" }, { v: "文山市" }, { v: "砚山县" }, { v: "西畴县" }, { v: "马关县" }, { v: "麻栗坡县" }],
      },
      {
        v: "昆明市",
        c: [
          { v: "东���区" },
          { v: "五华区" },
          { v: "呈贡区" },
          { v: "安宁市" },
          { v: "官渡区" },
          { v: "宜良县" },
          { v: "富民县" },
          { v: "寻甸回族彝族自治县 " },
          { v: "嵩明县" },
          { v: "晋宁区" },
          { v: "滇中新区" },
          { v: "盘龙区" },
          { v: "石林彝族自治县" },
          { v: "禄劝彝族苗族自治县" },
          { v: "西山区" },
          { v: "高新区" },
        ],
      },
      {
        v: "昭通市",
        c: [
          { v: "大关县" },
          { v: "威信县" },
          { v: "巧家县" },
          { v: "彝良县" },
          { v: "昭阳区" },
          { v: "水富县" },
          { v: "永善县" },
          { v: "盐津县" },
          { v: "绥江县" },
          { v: "镇雄县" },
          { v: "鲁甸县" },
        ],
      },
      {
        v: "普洱市",
        c: [
          { v: "墨江哈尼族自治县" },
          { v: "孟连傣族拉祜族佤族自治县" },
          { v: "宁洱哈尼族彝族自治县" },
          { v: "思茅区" },
          { v: "景东彝族自治县" },
          { v: "景谷傣族彝族自治县" },
          { v: "江城哈尼族彝族自治县" },
          { v: "澜沧拉祜族自治县" },
          { v: "西盟佤族自治县" },
          { v: "镇沅彝族哈尼族拉祜族自治县" },
        ],
      },
      {
        v: "曲靖市",
        c: [
          { v: "会泽县" },
          { v: "宣威市" },
          { v: "富源县" },
          { v: "师宗县" },
          { v: "沾益区" },
          { v: "罗平县" },
          { v: "陆良县" },
          { v: "马龙县" },
          { v: "麒麟区" },
        ],
      },
      {
        v: "楚雄彝族自治州",
        c: [
          { v: "元谋县" },
          { v: "南华县" },
          { v: "双柏县" },
          { v: "大姚县" },
          { v: "姚安县" },
          { v: "楚雄市" },
          { v: "武定县" },
          { v: "永仁县" },
          { v: "牟定县" },
          { v: "禄丰县" },
        ],
      },
      {
        v: "玉溪市",
        c: [
          { v: "元江哈尼族彝族傣族自治县" },
          { v: "华宁县" },
          { v: "峨山彝族自治县" },
          { v: "新平彝族傣族自治县" },
          { v: "易门县" },
          { v: "江川区" },
          { v: "澄江县" },
          { v: "红塔区" },
          { v: "通海县" },
        ],
      },
      {
        v: "红河哈尼族彝族自治州",
        c: [
          { v: "个旧市" },
          { v: "元阳县" },
          { v: "屏边苗族自治县" },
          { v: "建水县" },
          { v: "开远市" },
          { v: "弥勒市" },
          { v: "河口瑶族自治县" },
          { v: "泸西县" },
          { v: "石屏县" },
          { v: "红河县" },
          { v: "绿春县" },
          { v: "蒙自市" },
          { v: "金平苗族瑶族傣族自治县" },
        ],
      },
      { v: "西双版纳傣族自治州", c: [{ v: "勐海县" }, { v: "勐腊县" }, { v: "景洪市" }] },
      { v: "迪庆藏族自治州", c: [{ v: "德钦县" }, { v: "维西傈僳族自治县" }, { v: "香格里拉市" }] },
    ],
  },
  {
    v: "西藏自治区",
    c: [
      {
        v: "山南市",
        c: [
          { v: "乃东区" },
          { v: "加查县" },
          { v: "扎囊县" },
          { v: "措美县" },
          { v: "曲松县" },
          { v: "桑日县" },
          { v: "洛扎县" },
          { v: "浪卡子县" },
          { v: "琼结县" },
          { v: "贡嘎县" },
          { v: "错那县" },
          { v: "隆子县" },
        ],
      },
      {
        v: "拉萨市",
        c: [{ v: "城关区" }, { v: "堆龙德庆区" }, { v: "墨竹工卡县" }, { v: "尼木县" }, { v: "当雄县" }, { v: "曲水县" }, { v: "林周县" }, { v: "达孜县" }],
      },
      {
        v: "日喀则市",
        c: [
          { v: "亚东县" },
          { v: "仁布县" },
          { v: "仲巴县" },
          { v: "南木林县" },
          { v: "吉隆县" },
          { v: "定日县" },
          { v: "定结县" },
          { v: "岗巴县" },
          { v: "康马县" },
          { v: "拉孜县" },
          { v: "昂仁县" },
          { v: "桑珠孜区" },
          { v: "江孜县" },
          { v: "白朗县" },
          { v: "聂拉木县" },
          { v: "萨嘎县" },
          { v: "萨迦县" },
          { v: "谢通门县" },
        ],
      },
      {
        v: "昌都市",
        c: [
          { v: "丁青县" },
          { v: "八宿县" },
          { v: "卡若区" },
          { v: "察雅县" },
          { v: "左贡县" },
          { v: "江达县" },
          { v: "洛隆县" },
          { v: "类乌齐县" },
          { v: "芒康县" },
          { v: "贡觉县" },
          { v: "边坝县" },
        ],
      },
      { v: "林芝市", c: [{ v: "墨脱县" }, { v: "察隅县" }, { v: "工布江达县" }, { v: "巴宜区" }, { v: "朗县" }, { v: "波密县" }, { v: "米林县" }] },
      {
        v: "那曲地区",
        c: [
          { v: "双湖县" },
          { v: "嘉黎县" },
          { v: "安多县" },
          { v: "尼玛县" },
          { v: "巴青县" },
          { v: "比如县" },
          { v: "班戈县" },
          { v: "申扎县" },
          { v: "索县" },
          { v: "聂荣县" },
          { v: "那曲县" },
        ],
      },
      { v: "阿里地区", c: [{ v: "噶尔县" }, { v: "措勤县" }, { v: "改则县" }, { v: "日土县" }, { v: "普兰县" }, { v: "札达县" }, { v: "革吉县" }] },
    ],
  },
  {
    v: "陕西省",
    c: [
      {
        v: "咸阳市",
        c: [
          { v: "三原县" },
          { v: "乾县" },
          { v: "兴平市" },
          { v: "彬县" },
          { v: "旬邑县" },
          { v: "杨陵区" },
          { v: "武功县" },
          { v: "永寿县" },
          { v: "泾阳县" },
          { v: "淳化县" },
          { v: "渭城区" },
          { v: "礼泉县" },
          { v: "秦都区" },
          { v: "长武县" },
          { v: "高新区" },
        ],
      },
      { v: "商洛市", c: [{ v: "丹凤县" }, { v: "商南县" }, { v: "商州区" }, { v: "山阳县" }, { v: "柞水县" }, { v: "洛南县" }, { v: "镇安县" }] },
      {
        v: "安康市",
        c: [
          { v: "宁陕县" },
          { v: "岚皋县" },
          { v: "平利县" },
          { v: "旬阳县" },
          { v: "汉滨区" },
          { v: "汉阴县" },
          { v: "白河县" },
          { v: "石泉县" },
          { v: "紫阳县" },
          { v: "镇坪县" },
        ],
      },
      {
        v: "宝鸡市",
        c: [
          { v: "凤县" },
          { v: "凤翔县" },
          { v: "千阳县" },
          { v: "太白县" },
          { v: "岐山县" },
          { v: "扶风县" },
          { v: "渭滨区" },
          { v: "眉县" },
          { v: "金台区" },
          { v: "陇县" },
          { v: "陈仓区" },
          { v: "高新区" },
          { v: "麟游县" },
        ],
      },
      {
        v: "延安市",
        c: [
          { v: "吴起县" },
          { v: "子长县" },
          { v: "安塞区" },
          { v: "宜川县" },
          { v: "宝塔区" },
          { v: "富县" },
          { v: "延川县" },
          { v: "延长县" },
          { v: "志丹县" },
          { v: "洛川县" },
          { v: "甘泉县" },
          { v: "黄陵县" },
          { v: "黄龙县" },
        ],
      },
      {
        v: "榆林市",
        c: [
          { v: "佳县" },
          { v: "吴堡县" },
          { v: "子洲县" },
          { v: "定边县" },
          { v: "府谷县" },
          { v: "榆阳区" },
          { v: "横山区" },
          { v: "清涧县" },
          { v: "神木县" },
          { v: "米脂县" },
          { v: "绥德县" },
          { v: "靖边县" },
        ],
      },
      {
        v: "汉中市",
        c: [
          { v: "佛坪县" },
          { v: "勉县" },
          { v: "南郑县" },
          { v: "城固县" },
          { v: "宁强县" },
          { v: "汉台区" },
          { v: "洋县" },
          { v: "留坝县" },
          { v: "略阳县" },
          { v: "西乡县" },
          { v: "镇巴县" },
        ],
      },
      {
        v: "渭南市",
        c: [
          { v: "临渭区" },
          { v: "华州区" },
          { v: "华阴市" },
          { v: "合阳县" },
          { v: "大荔县" },
          { v: "富平县" },
          { v: "潼关县" },
          { v: "澄城县" },
          { v: "白水县" },
          { v: "蒲城县" },
          { v: "韩城市" },
        ],
      },
      { v: "西咸新区", c: [{ v: "沣东新城" }, { v: "沣西新城" }, { v: "泾河新城" }, { v: "秦汉新城" }, { v: "空港新城" }] },
      {
        v: "西安市",
        c: [
          { v: "临潼区" },
          { v: "周至县" },
          { v: "新城区" },
          { v: "曲江新区" },
          { v: "未央区" },
          { v: "灞桥区" },
          { v: "碑林区" },
          { v: "莲湖区" },
          { v: "蓝田县" },
          { v: "鄠邑区" },
          { v: "长安区" },
          { v: "阎良区" },
          { v: "雁塔区" },
          { v: "高新区" },
          { v: "高陵区" },
        ],
      },
      { v: "铜川市", c: [{ v: "印台区" }, { v: "宜君县" }, { v: "王益区" }, { v: "耀州区" }] },
    ],
  },
  {
    v: "甘肃省",
    c: [
      {
        v: "临夏回族自治州",
        c: [
          { v: "东乡族自治县" },
          { v: "临夏县" },
          { v: "临夏市" },
          { v: "和政县" },
          { v: "广河县" },
          { v: "康乐县" },
          { v: "永靖县" },
          { v: "积石山保安族东乡族撒拉族自治县" },
        ],
      },
      {
        v: "兰州市",
        c: [
          { v: "七里河区" },
          { v: "兰州新区" },
          { v: "城关区" },
          { v: "安宁区" },
          { v: "榆中县" },
          { v: "永登县" },
          { v: "皋兰县" },
          { v: "红古区" },
          { v: "经济开发区" },
          { v: "西固区" },
          { v: "高新区" },
        ],
      },
      { v: "嘉峪关市", c: [{ v: "镜铁区" }, { v: "长城区" }, { v: "雄关区" }] },
      { v: "天水市", c: [{ v: "张家川回族自治县" }, { v: "武山县" }, { v: "清水县" }, { v: "甘谷县" }, { v: "秦安县" }, { v: "秦州区" }, { v: "麦积区" }] },
      { v: "定西市", c: [{ v: "临洮县" }, { v: "安定区" }, { v: "岷县" }, { v: "渭源县" }, { v: "漳县" }, { v: "通渭县" }, { v: "陇西县" }] },
      { v: "平凉市", c: [{ v: "华亭县" }, { v: "崆峒区" }, { v: "崇信县" }, { v: "庄浪县" }, { v: "泾川县" }, { v: "灵台县" }, { v: "静宁县" }] },
      { v: "庆阳市", c: [{ v: "华池县" }, { v: "合水县" }, { v: "宁县" }, { v: "庆城县" }, { v: "正宁县" }, { v: "环县" }, { v: "西峰区" }, { v: "镇原县" }] },
      { v: "张掖市", c: [{ v: "临泽县" }, { v: "山丹县" }, { v: "民乐县" }, { v: "甘州区" }, { v: "肃南裕固族自治县" }, { v: "高台县" }] },
      { v: "武威市", c: [{ v: "凉州区" }, { v: "古浪县" }, { v: "天祝藏族自治县" }, { v: "民勤县" }] },
      {
        v: "甘南藏族自治州",
        c: [{ v: "临潭县" }, { v: "卓尼县" }, { v: "合作市" }, { v: "夏河县" }, { v: "玛曲县" }, { v: "碌曲县" }, { v: "舟曲县" }, { v: "迭部县" }],
      },
      { v: "白银市", c: [{ v: "会宁县" }, { v: "平川区" }, { v: "景泰县" }, { v: "白银区" }, { v: "靖远县" }] },
      {
        v: "酒泉市",
        c: [{ v: "敦煌市" }, { v: "玉门市" }, { v: "瓜州县" }, { v: "肃北蒙古族自治县" }, { v: "肃州区" }, { v: "金塔县" }, { v: "阿克塞哈萨克族自治县" }],
      },
      { v: "金昌市", c: [{ v: "永昌县" }, { v: "金川区" }] },
      {
        v: "陇南市",
        c: [{ v: "两当县" }, { v: "宕昌县" }, { v: "康县" }, { v: "徽县" }, { v: "成县" }, { v: "文县" }, { v: "武都区" }, { v: "礼县" }, { v: "西和县" }],
      },
    ],
  },
  {
    v: "青海省",
    c: [
      { v: "果洛藏族自治州", c: [{ v: "久治县" }, { v: "玛多县" }, { v: "玛沁县" }, { v: "班玛县" }, { v: "甘德县" }, { v: "达日县" }] },
      {
        v: "海东市",
        c: [{ v: "乐都区" }, { v: "互助土族自治县" }, { v: "化隆回族自治县" }, { v: "平安区" }, { v: "循化撒拉族自治县" }, { v: "民和回族土族自治县" }],
      },
      { v: "海北藏族自治州", c: [{ v: "刚察县" }, { v: "海晏县" }, { v: "祁连县" }, { v: "门源回族自治县" }] },
      { v: "海南藏族自治州", c: [{ v: "共和县" }, { v: "兴海县" }, { v: "同德县" }, { v: "贵南县" }, { v: "贵德县" }] },
      { v: "海西蒙古族藏族自治州", c: [{ v: "乌兰县" }, { v: "天峻县" }, { v: "德令哈市" }, { v: "格尔木市" }, { v: "都兰县" }] },
      { v: "玉树藏族自治州", c: [{ v: "囊谦县" }, { v: "曲麻莱县" }, { v: "杂多县" }, { v: "治多县" }, { v: "玉树市" }, { v: "称多县" }] },
      { v: "西宁市", c: [{ v: "城东区" }, { v: "城中区" }, { v: "城北区" }, { v: "城西区" }, { v: "大通回族土族自治县" }, { v: "湟中县" }, { v: "湟源县" }] },
      { v: "黄南藏族自治州", c: [{ v: "同仁县" }, { v: "尖扎县" }, { v: "河南蒙古族自治县" }, { v: "泽库县" }] },
    ],
  },
  {
    v: "宁夏回族自治区",
    c: [
      { v: "中卫市", c: [{ v: "中宁县" }, { v: "沙坡头区" }, { v: "海原县" }] },
      { v: "吴忠市", c: [{ v: "利通区" }, { v: "同心县" }, { v: "盐池县" }, { v: "红寺堡区" }, { v: "青铜峡市" }] },
      { v: "固原市", c: [{ v: "原州区" }, { v: "彭阳县" }, { v: "泾源县" }, { v: "西吉县" }, { v: "隆德县" }] },
      { v: "石嘴山市", c: [{ v: "大武口区" }, { v: "平罗县" }, { v: "惠农区" }, { v: "经济开发区" }] },
      { v: "银川市", c: [{ v: "兴庆区" }, { v: "永宁县" }, { v: "灵武市" }, { v: "经济开发区" }, { v: "西夏区" }, { v: "贺兰县" }, { v: "金凤区" }] },
    ],
  },
  {
    v: "新疆维吾尔自治区",
    c: [
      {
        v: "乌鲁木齐市",
        c: [
          { v: "乌鲁木齐县" },
          { v: "天山区" },
          { v: "头屯河区" },
          { v: "新市区" },
          { v: "水磨沟区" },
          { v: "沙依巴克区" },
          { v: "米东区" },
          { v: "达坂城区" },
        ],
      },
      { v: "五家渠市", c: [{ v: "一零一团" }, { v: "一零三团" }, { v: "一零二团" }, { v: "城区" }] },
      {
        v: "伊犁哈萨克自治州",
        c: [
          { v: "伊宁县" },
          { v: "伊宁市" },
          { v: "奎屯市" },
          { v: "察布查尔锡伯自治县" },
          { v: "尼勒克县" },
          { v: "巩留县" },
          { v: "新源县" },
          { v: "昭苏县" },
          { v: "特克斯县" },
          { v: "霍城县" },
          { v: "霍尔果斯市" },
        ],
      },
      { v: "克孜勒苏柯尔克孜自治州", c: [{ v: "乌恰县" }, { v: "阿克陶县" }, { v: "阿合奇县" }, { v: "阿图什市" }] },
      { v: "克拉玛依市", c: [{ v: "乌尔禾区" }, { v: "克拉玛依区" }, { v: "独山子区" }, { v: "白碱滩区" }] },
      { v: "北屯市", c: [{ v: "丰庆镇" }, { v: "工业园区" }, { v: "新城区" }, { v: "海川镇" }, { v: "老城区" }, { v: "锡伯渡镇" }] },
      { v: "博尔塔拉蒙古自治州", c: [{ v: "博乐市" }, { v: "温泉县" }, { v: "精河县" }, { v: "阿拉山口市" }] },
      { v: "双河市", c: [{ v: "九十团" }, { v: "八十一团" }, { v: "八十九团" }, { v: "八十五团" }, { v: "八十六团" }, { v: "八十四团" }] },
      { v: "可克达拉市", c: [{ v: "63团" }, { v: "64团" }, { v: "66团" }, { v: "67团" }, { v: "68团" }] },
      { v: "吐鲁番市", c: [{ v: "托克逊县" }, { v: "鄯善县" }, { v: "高昌区" }] },
      {
        v: "和田地区",
        c: [{ v: "于田县" }, { v: "和田县" }, { v: "和田市" }, { v: "墨玉县" }, { v: "民丰县" }, { v: "洛浦县" }, { v: "皮山县" }, { v: "策勒县" }],
      },
      { v: "哈密市", c: [{ v: "伊吾县" }, { v: "伊州区" }, { v: "巴里坤哈萨克自治县" }] },
      {
        v: "喀什地区",
        c: [
          { v: "伽师县" },
          { v: "叶城县" },
          { v: "喀什市" },
          { v: "塔什库尔干塔吉克自治县" },
          { v: "岳普湖县" },
          { v: "巴楚县" },
          { v: "泽普县" },
          { v: "疏勒县" },
          { v: "疏附县" },
          { v: "英吉沙县" },
          { v: "莎车县" },
          { v: "麦盖提县" },
        ],
      },
      {
        v: "图木舒克市",
        c: [
          { v: "兵团五十一团" },
          { v: "兵团五十三团" },
          { v: "兵团五十二团" },
          { v: "兵团五十团" },
          { v: "兵团四十九团" },
          { v: "兵团四十四团" },
          { v: "喀拉拜勒镇" },
          { v: "图木舒克市区" },
          { v: "永安坝" },
        ],
      },
      {
        v: "塔城地区",
        c: [{ v: "乌苏市" }, { v: "和布克赛尔蒙古自治县" }, { v: "塔城市" }, { v: "托里县" }, { v: "沙湾县" }, { v: "裕民县" }, { v: "额敏县" }],
      },
      {
        v: "巴音郭楞蒙古自治州",
        c: [
          { v: "且末县" },
          { v: "博湖县" },
          { v: "和硕县" },
          { v: "和静县" },
          { v: "尉犁县" },
          { v: "库尔勒市" },
          { v: "焉耆回族自治县" },
          { v: "若羌县" },
          { v: "轮台县" },
        ],
      },
      { v: "昆玉市", c: [{ v: "一牧场" }, { v: "二二四团" }, { v: "四十七团" }, { v: "皮山农场" }] },
      {
        v: "昌吉回族自治州",
        c: [{ v: "吉木萨尔县" }, { v: "呼图壁县" }, { v: "奇台县" }, { v: "昌吉市" }, { v: "木垒哈萨克自治县" }, { v: "玛纳斯县" }, { v: "阜康市" }],
      },
      {
        v: "石河子市",
        c: [
          { v: "一五二团" },
          { v: "东城街道" },
          { v: "北泉镇" },
          { v: "向阳街道" },
          { v: "新城街道" },
          { v: "石河子乡" },
          { v: "红山街道" },
          { v: "老街街道" },
        ],
      },
      { v: "铁门关市", c: [{ v: "二十九团场" }, { v: "博古其镇" }, { v: "双丰镇" }, { v: "库西经济工业园" }] },
      {
        v: "阿克苏地区",
        c: [
          { v: "乌什县" },
          { v: "库车县" },
          { v: "拜城县" },
          { v: "新和县" },
          { v: "柯坪县" },
          { v: "沙雅县" },
          { v: "温宿县" },
          { v: "阿克苏市" },
          { v: "阿瓦提县" },
        ],
      },
      { v: "阿勒泰地区", c: [{ v: "吉木乃县" }, { v: "哈巴河县" }, { v: "富蕴县" }, { v: "布尔津县" }, { v: "福海县" }, { v: "阿勒泰市" }, { v: "青河县" }] },
      { v: "阿拉尔市", c: [{ v: "南口街道" }, { v: "幸福路街道" }, { v: "托喀依乡" }, { v: "金银川路街道" }, { v: "金银川镇" }, { v: "青松路街道" }] },
    ],
  },
  {
    v: "台湾省",
    c: [
      {
        v: "云林县",
        c: [
          { v: "东势乡" },
          { v: "二仑乡" },
          { v: "仑背乡" },
          { v: "元长乡" },
          { v: "北港镇" },
          { v: "口湖乡" },
          { v: "古坑乡" },
          { v: "台西乡" },
          { v: "四湖乡" },
          { v: "土库镇" },
          { v: "大埤乡" },
          { v: "斗六市" },
          { v: "斗南镇" },
          { v: "林内乡" },
          { v: "水林乡" },
          { v: "莿桐乡" },
          { v: "虎尾镇" },
          { v: "褒忠乡" },
          { v: "西螺镇" },
          { v: "麦寮乡" },
        ],
      },
      {
        v: "南投县",
        c: [
          { v: "中寮乡" },
          { v: "仁爱乡" },
          { v: "信义乡" },
          { v: "南投市" },
          { v: "名间乡" },
          { v: "国姓乡" },
          { v: "埔里镇" },
          { v: "水里乡" },
          { v: "竹山镇" },
          { v: "草屯镇" },
          { v: "集集镇" },
          { v: "鱼池乡" },
          { v: "鹿谷乡" },
        ],
      },
      {
        v: "台东县",
        c: [
          { v: "东河乡" },
          { v: "兰屿乡" },
          { v: "关山镇" },
          { v: "卑南乡" },
          { v: "台东市" },
          { v: "大武乡" },
          { v: "太麻里乡" },
          { v: "延平乡" },
          { v: "成功镇" },
          { v: "池上乡" },
          { v: "海端乡" },
          { v: "绿岛乡" },
          { v: "达仁乡" },
          { v: "金峰乡" },
          { v: "长滨乡" },
          { v: "鹿野乡" },
        ],
      },
      {
        v: "台中市",
        c: [
          { v: "东势区" },
          { v: "东区" },
          { v: "中区" },
          { v: "丰原区" },
          { v: "乌日区" },
          { v: "北区" },
          { v: "北屯区" },
          { v: "南区" },
          { v: "南屯区" },
          { v: "后里区" },
          { v: "和平区" },
          { v: "外埔区" },
          { v: "大安区" },
          { v: "大甲区" },
          { v: "大肚区" },
          { v: "大里区" },
          { v: "大雅区" },
          { v: "太平区" },
          { v: "新社区" },
          { v: "梧栖区" },
          { v: "沙鹿区" },
          { v: "清水区" },
          { v: "潭子区" },
          { v: "石冈区" },
          { v: "神冈区" },
          { v: "西区" },
          { v: "西屯区" },
          { v: "雾峰区" },
          { v: "龙井区" },
        ],
      },
      {
        v: "台北市",
        c: [
          { v: "万华区" },
          { v: "中山区" },
          { v: "中正区" },
          { v: "信义区" },
          { v: "内湖区" },
          { v: "北投区" },
          { v: "南港区" },
          { v: "士林区" },
          { v: "大同区" },
          { v: "大安区" },
          { v: "文山区" },
          { v: "松山区" },
        ],
      },
      {
        v: "台南市",
        c: [
          { v: "七股区" },
          { v: "下营区" },
          { v: "东区" },
          { v: "东山区" },
          { v: "中西区" },
          { v: "仁德区" },
          { v: "佳里区" },
          { v: "六甲区" },
          { v: "关庙区" },
          { v: "北区" },
          { v: "北门区" },
          { v: "南化区" },
          { v: "南区" },
          { v: "后壁区" },
          { v: "善化区" },
          { v: "大内区" },
          { v: "学甲区" },
          { v: "安南区" },
          { v: "安定区" },
          { v: "安平区" },
          { v: "官田区" },
          { v: "将军区" },
          { v: "山上区" },
          { v: "左镇区" },
          { v: "归仁区" },
          { v: "新化区" },
          { v: "新市区" },
          { v: "新营区" },
          { v: "柳营区" },
          { v: "楠西区" },
          { v: "永康区" },
          { v: "玉井区" },
          { v: "白河区" },
          { v: "盐水区" },
          { v: "西港区" },
          { v: "麻豆区" },
          { v: "龙崎区" },
        ],
      },
      {
        v: "嘉义县",
        c: [
          { v: "东石乡" },
          { v: "中埔乡" },
          { v: "义竹乡" },
          { v: "六脚乡" },
          { v: "大埔乡" },
          { v: "大林镇" },
          { v: "太保市" },
          { v: "布袋镇" },
          { v: "新港乡" },
          { v: "朴子市" },
          { v: "梅山乡" },
          { v: "民雄乡" },
          { v: "水上乡" },
          { v: "溪口乡" },
          { v: "番路乡" },
          { v: "竹崎乡" },
          { v: "阿里山乡" },
          { v: "鹿草乡" },
        ],
      },
      { v: "嘉义市", c: [{ v: "东区" }, { v: "西区" }] },
      { v: "基隆市", c: [{ v: "七堵区" }, { v: "中山区" }, { v: "中正区" }, { v: "仁爱区" }, { v: "信义区" }, { v: "安乐区" }, { v: "暖暖区" }] },
      {
        v: "宜兰县",
        c: [
          { v: "三星乡" },
          { v: "五结乡" },
          { v: "冬山乡" },
          { v: "南澳乡" },
          { v: "员山乡" },
          { v: "壮围乡" },
          { v: "大同乡" },
          { v: "头城镇" },
          { v: "宜兰市" },
          { v: "礁溪乡" },
          { v: "罗东镇" },
          { v: "苏澳镇" },
        ],
      },
      {
        v: "屏东县",
        c: [
          { v: "万丹乡" },
          { v: "万峦乡" },
          { v: "三地门乡" },
          { v: "东港镇" },
          { v: "九如乡" },
          { v: "佳冬乡" },
          { v: "内埔乡" },
          { v: "南州乡" },
          { v: "屏东市" },
          { v: "崁顶乡" },
          { v: "恒春镇" },
          { v: "新园乡" },
          { v: "新埤乡" },
          { v: "春日乡" },
          { v: "来义乡" },
          { v: "枋寮乡" },
          { v: "枋山乡" },
          { v: "林边乡" },
          { v: "泰武乡" },
          { v: "满州乡" },
          { v: "潮州镇" },
          { v: "牡丹乡" },
          { v: "狮子乡" },
          { v: "玛家乡" },
          { v: "琉球乡" },
          { v: "盐埔乡" },
          { v: "竹田乡" },
          { v: "车城乡" },
          { v: "里港乡" },
          { v: "长治乡" },
          { v: "雾台乡" },
          { v: "高树乡" },
          { v: "麟洛乡" },
        ],
      },
      {
        v: "彰化县",
        c: [
          { v: "二林镇" },
          { v: "二水乡" },
          { v: "伸港乡" },
          { v: "北斗镇" },
          { v: "员林市" },
          { v: "和美镇" },
          { v: "埔心乡" },
          { v: "埔盐乡" },
          { v: "埤头乡" },
          { v: "大城乡" },
          { v: "大村乡" },
          { v: "彰化市" },
          { v: "永靖乡" },
          { v: "溪州乡" },
          { v: "溪湖镇" },
          { v: "田中镇" },
          { v: "田尾乡" },
          { v: "社头乡" },
          { v: "福兴乡" },
          { v: "秀水乡" },
          { v: "竹塘乡" },
          { v: "线西乡" },
          { v: "芬园乡" },
          { v: "花坛乡" },
          { v: "芳苑乡" },
          { v: "鹿港镇" },
        ],
      },
      {
        v: "新北市",
        c: [
          { v: "��峡区" },
          { v: "万里区" },
          { v: "三芝区" },
          { v: "三重区" },
          { v: "中和区" },
          { v: "乌来区" },
          { v: "五股区" },
          { v: "八里区" },
          { v: "双溪区" },
          { v: "土城区" },
          { v: "坪林区" },
          { v: "平溪区" },
          { v: "新庄区" },
          { v: "新店区" },
          { v: "板桥区" },
          { v: "林口区" },
          { v: "树林区" },
          { v: "永和区" },
          { v: "汐止区" },
          { v: "泰山区" },
          { v: "淡水区" },
          { v: "深坑区" },
          { v: "瑞芳区" },
          { v: "石碇区" },
          { v: "石门区" },
          { v: "芦洲区" },
          { v: "莺歌区" },
          { v: "贡寮区" },
          { v: "金山区" },
        ],
      },
      {
        v: "新竹县",
        c: [
          { v: "五峰乡" },
          { v: "关西镇" },
          { v: "北埔乡" },
          { v: "宝山乡" },
          { v: "尖石乡" },
          { v: "峨眉乡" },
          { v: "新丰乡" },
          { v: "新埔镇" },
          { v: "横山乡" },
          { v: "湖口乡" },
          { v: "竹东镇" },
          { v: "竹北市" },
          { v: "芎林乡" },
        ],
      },
      { v: "新竹市", c: [{ v: "东区" }, { v: "北区" }, { v: "香山区" }] },
      {
        v: "桃园市",
        c: [
          { v: "中坜市" },
          { v: "八德市" },
          { v: "复兴乡" },
          { v: "大园乡" },
          { v: "大溪镇" },
          { v: "平镇市" },
          { v: "新屋乡" },
          { v: "杨梅市" },
          { v: "桃园市" },
          { v: "芦竹市" },
          { v: "观音乡" },
          { v: "龙潭乡" },
          { v: "龟山乡" },
        ],
      },
      { v: "澎湖县", c: [{ v: "七美乡" }, { v: "望安乡" }, { v: "湖西乡" }, { v: "白沙乡" }, { v: "西屿乡" }, { v: "马公市" }] },
      {
        v: "花莲县",
        c: [
          { v: "万荣乡" },
          { v: "丰滨乡" },
          { v: "光复乡" },
          { v: "凤林镇" },
          { v: "卓溪乡" },
          { v: "吉安乡" },
          { v: "富里乡" },
          { v: "寿丰乡" },
          { v: "新城乡" },
          { v: "玉里镇" },
          { v: "瑞穗乡" },
          { v: "秀林乡" },
          { v: "花莲市" },
        ],
      },
      {
        v: "苗栗县",
        c: [
          { v: "三义乡" },
          { v: "三湾乡" },
          { v: "公馆乡" },
          { v: "卓兰镇" },
          { v: "南庄乡" },
          { v: "后龙镇" },
          { v: "大湖乡" },
          { v: "头份市" },
          { v: "头屋乡" },
          { v: "泰安乡" },
          { v: "狮潭乡" },
          { v: "竹南镇" },
          { v: "苑里镇" },
          { v: "苗栗市" },
          { v: "西湖乡" },
          { v: "通霄镇" },
          { v: "造桥乡" },
          { v: "铜锣乡" },
        ],
      },
      { v: "连江县", c: [{ v: "东引乡" }, { v: "北竿乡" }, { v: "南竿乡" }, { v: "莒光乡" }] },
      { v: "金门县", c: [{ v: "乌丘乡" }, { v: "烈屿乡" }, { v: "金城镇" }, { v: "金宁乡" }, { v: "金沙镇" }, { v: "金湖镇" }] },
      {
        v: "高雄市",
        c: [
          { v: "三民区" },
          { v: "仁武区" },
          { v: "六龟区" },
          { v: "内门区" },
          { v: "冈山区" },
          { v: "凤山区" },
          { v: "前金区" },
          { v: "前镇区" },
          { v: "大寮区" },
          { v: "大树区" },
          { v: "大社区" },
          { v: "小港区" },
          { v: "左营区" },
          { v: "弥陀区" },
          { v: "新兴区" },
          { v: "旗山区" },
          { v: "旗津区" },
          { v: "杉林区" },
          { v: "林园区" },
          { v: "桃源区" },
          { v: "桥头区" },
          { v: "梓官区" },
          { v: "楠梓区" },
          { v: "永安区" },
          { v: "湖内区" },
          { v: "燕巢区" },
          { v: "田寮区" },
          { v: "甲仙区" },
          { v: "盐埕区" },
          { v: "美浓区" },
          { v: "苓雅区" },
          { v: "茂林区" },
          { v: "茄萣区" },
          { v: "路竹区" },
          { v: "那玛夏区" },
          { v: "阿莲区" },
          { v: "鸟松区" },
          { v: "鼓山区" },
        ],
      },
    ],
  },
  {
    v: "香港特别行政区",
    c: [
      { v: "九龙", c: [{ v: "九龙城区" }, { v: "油尖旺区" }, { v: "深水埗区" }, { v: "观塘区" }, { v: "黄大仙区" }] },
      {
        v: "新界",
        c: [
          { v: "元朗区" },
          { v: "北区" },
          { v: "大埔区" },
          { v: "屯门区" },
          { v: "沙田区" },
          { v: "离岛区" },
          { v: "荃湾区" },
          { v: "葵青区" },
          { v: "西贡区" },
        ],
      },
      { v: "香港岛", c: [{ v: "东区" }, { v: "中西区" }, { v: "南区" }, { v: "湾仔区" }] },
    ],
  },
  {
    v: "澳门特别行政区",
    c: [
      { v: "氹仔岛", c: [{ v: "嘉模堂区" }] },
      { v: "澳门半岛", c: [{ v: "圣安多尼堂区" }, { v: "大堂区" }, { v: "望德堂区" }, { v: "花地玛堂区" }, { v: "风顺堂区" }] },
      { v: "路环岛", c: [{ v: "圣方济各堂区" }] },
    ],
  },
];
